import { injectPersonalData } from '../pages/impressum/impressumUtils.js';

const baseTranslationBG = {
  title: 'Правна информация',
  subtitle: 'Информация съгласно § 5 DDG (германски Закон за цифровите услуги)',
  serviceProvider: 'Доставчик на услуги', contactTitle: 'Контакт', addressLabel: 'Адрес', contactLabel: 'Имейл адрес', professionalTitle: 'Данни за дружеството', professionLabel: 'Правна форма', businessTypeLabel: 'Вид дейност', taxTitle: 'Данъчна информация', liabilityTitle: 'Информация за отговорността', contentLiabilityTitle: 'Отговорност за съдържанието', contentLiability: 'Като доставчик на услуги носим отговорност за собственото си съдържание на тези страници съгласно § 7, ал. 1 DDG и общите закони. Съгласно §§ 8–10 DDG обаче като доставчик на услуги не сме задължени да следим предаваната или съхраняваната чужда информация, нито да издирваме обстоятелства, които сочат противоправна дейност.', linkLiabilityTitle: 'Отговорност за връзките', linkLiability: 'Нашият уебсайт съдържа връзки към външни уебсайтове на трети страни, върху чието съдържание нямаме влияние. Затова не можем да поемем гаранция за това чуждо съдържание. За съдържанието на свързаните страници винаги отговаря съответният доставчик или оператор на страниците. Към момента на поставяне на връзките свързаните страници бяха проверени за евентуални правонарушения. Към този момент не беше установено противоправно съдържание.', copyrightTitle: 'Авторско право', copyright: 'Съдържанието и произведенията, създадени от операторите на тези страници, са обект на германското авторско право. Възпроизвеждането, обработката, разпространението и всякакъв вид използване извън границите на авторското право изискват писменото съгласие на съответния автор или създател. Изтегляния и копия на тези страници са разрешени само за лична, нетърговска употреба.'
};

export const localeBG = {
  nav: { title: 'pAIoneer Labs GmbH', home: 'Начало', team: 'Екип', events: 'Събития', finance: 'Финансов ИИ', teaching: 'Обучения',agenticdev: 'IDD / Агентно програмиране', iddLegacy: 'Модернизация на наследен софтуер', iddMethod: 'Intent-Driven Development', veridion: 'Veridion', kyveil: 'Анонимизация', quantum: 'Квантови технологии',login: 'Вход', openApp: 'Отваряне на приложението', account: 'Профил', admin: 'Администрация', logout: 'Изход', languageNames: { en: 'Английски', de: 'Немски', nl: 'Нидерландски', uk: 'Украински', fr: 'Френски', it: 'Италиански', es: 'Испански', sv: 'Шведски', fi: 'Фински', ja: 'Японски', pl: 'Полски', bg: 'Български' } },
  admin: {
    datalake: {
      loading: "Зареждане …",
      loadFailed: "Data lake е недостъпен",
      refresh: "Обнови",
      generatedAt: "Към момент",
      notRolled: "Тази област още не е разгърната в бекенда. Щом новите крайни точки заработят, тук ще се появи измереното състояние.",
      loadMore: "Зареди още",
      yes: "да",
      no: "не",
      none: "няма",
      close: "Затвори",
      summaryTitle: "Две хипотези, една работна маса",
      summaryBody: "Хипотезата за архитектурата казва: математическият съд решава какво може да стане моделът — тя живее на страницата на LLM статията. Хипотезата за данните казва: само свързани, верифицирани обучителни данни пълнят този съд — на нея служи тази страница. Автопилотът непрекъснато пълни масива от данни, стартира обучението, щом планът за данни от статията е достигнат във всяка област на немски и английски, измерва резултата с бенчмарк пакета и публикува модела частно в HuggingFace. Всяко число тук е измерено или обозначено като конфигурирана стойност.",
      summaryArchButton: "Към хипотезата за архитектурата (LLM статия)",
      apTitle: "Автопилот",
      tpTitle: "Път до старта на обучението",
      tpSubtitle: "Къде е автопилотът сега: всяка стъпка до работещото обучение със състояние, време и напредък.",
      tpNow: "Сега",
      tpStep: "Стъпка",
      tpOf: "от",
      tpSince: "от",
      tpFor: "работи от",
      tpHeartbeat: "последен признак на живот",
      tpDone: "готово",
      tpRunning: "работи",
      tpWaiting: "чака",
      tpFailed: "неуспешно",
      tpSkipped: "пропуснато",
      tpProgress: "Напредък",
      tpRows: "реда",
      tpRate: "в секунда",
      tpRemaining: "оставащо време (оценка)",
      tpEstimateNote: "оценка от измерените броячи",
      tpPhaseReading: "чете пакет с данни",
      tpPhaseAdmission: "допускане (дубликати, ентропия)",
      tpPhaseEncoding: "токенизиране",
      tpNoTiming: "Тази версия на двигателя още не отчита времена.",
      tpBlockers: "Блокери и грешки",
      tpNone: "Няма блокери.",
      trTitle: "Тренировъчно изпълнение (на живо)",
      trSubtitle: "Чете се директно от директорията на изпълнението на тренера — работи и докато worker-ът се рестартира.",
      trNoRun: "Все още няма тренировъчно изпълнение с данни за напредъка.",
      trStateTraining: "тренира",
      trStateStarting: "стартира",
      trStateFinished: "завършено",
      trStateSilent: "мълчи от {age}",
      trStep: "Стъпка",
      trOf: "от",
      trRemaining: "Оставащо време (оценка по измерената скорост)",
      trSecondsPerStep: "s на стъпка",
      trProgress: "Напредък на планираните стъпки",
      trRun: "Изпълнение",
      trResumed: "продължено от стъпка {step}",
      trVersion: "Версия на тренировъчните данни",
      trModel: "Модел",
      trTokensPerSecond: "Токени/s",
      trTokensSeen: "Видени токени",
      trVram: "GPU памет",
      trCap: "лимит",
      trLastHeartbeat: "Последен heartbeat",
      trAgo: "преди {age}",
      trShardReads: "Четения на шардове локално / през worker-а",
      trLossTitle: "Ход на загубата (loss)",
      trLossTotal: "Общо",
      trLossNtp: "Следващ токен",
      trLossMtp: "Много токени",
      trChartEmpty: "Все още няма отчетени стъпки.",
      trAxisNote: "Хоризонтално: тренировъчна стъпка, вертикално: загуба (естествен логаритъм). Посочете кривата с мишката, за да видите стойностите на стъпка.",
      trValue: "Стойност",
      trCurrentValue: "текущо",
      trPoints: "{count} точки на измерване общо",
      trStages: "Етапи на учебния план",
      trStageFoundation: "Основа (суров текст)",
      trStageCapability: "Способности",
      trStageAnneal: "Anneal",
      trStageCurrent: "тече",
      trStageDone: "завършен",
      trStageAhead: "предстои",
      trShards: "шарда",
      trRows: "реда",
      trCheckpoint: "Най-нов checkpoint",
      trCheckpointNone: "още няма",
      trCheckpoints: "Пълни checkpoints на диска",
      trCheckpointEvery: "на всеки {minutes} мин",
      trKernels: "Активни ядра (kernels)",
      trDeviations: "Отклонения",
      trBlockStorage: "Копие в block storage",
      trBlockStorageNone: "още няма — първото идва след първия checkpoint",
      trUploading: "качване: стъпка {step}",
      treeCkRun: "Тренировъчно изпълнение",
      treeCkCopy: "Checkpoint в block storage, копиран {time}",
      treeCkLocal: "Checkpoint на диска на сървъра",
      treeCkUploading: "копира се в block storage в момента",
      trKpiProgress: "Напредък",
      trKpiTokens: "Токени",
      trKpiThroughput: "Пропускателна способност",
      trKpiLoss: "Загуба",
      trKpiLr: "Скорост на обучение",
      trKpiGpu: "GPU памет",
      trEndAt: "край около {time}",
      trSeenPlanned: "видени / планирани",
      trBest: "най-добра {value}",
      trHourAgo: "{value} спрямо преди 1 ч",
      trPerplexity: "перплексия {value}",
      trPhaseWarmup: "загряване",
      trPhaseCosine: "косинусово намаляване",
      trPhaseStable: "стабилна фаза",
      trPhaseDecay: "охлаждане",
      trKpiEpoch: "Епоха",
      trEpochValue: "{epoch} от {epochs}",
      trPlanTitle: "План на обучението",
      trPlanExplain: "Загряване до пиковата скорост на обучение, след това постоянна през четири смесени епохи на корпуса; фазата на охлаждане обучава върху най-висококачествената смес (примери за умения, учебникови текстове, anneal) и сваля скоростта на обучение до нула.",
      trPlanPhase: "Фаза",
      trPlanStableSteps: "Планирани стъпки на стабилната фаза",
      trPlanDecay: "Охлаждане",
      trPlanDecayAhead: "от стъпка {step} · след около {time}",
      trPlanDecayAheadNoTime: "от стъпка {step}",
      trPlanDecayRunning: "от стъпка {step} · {steps} стъпки до скорост на обучение нула",
      trPlanTokensPerStep: "Токени на стъпка на оптимизация",
      trPlanTokensPerStepValue: "{tokens} ({accum} микропартиди)",
      trPlanRecompute: "Преизчисляване на активациите",
      trPlanRecomputeOn: "включено – измерено по-бързо с по-голяма микропартида",
      trPlanRecomputeOff: "изключено – измерено по-бързо без",
      trPlanFim: "Документи във формат fill-in-the-middle досега",
      tbTitle: "Учебникова програма",
      tbSubtitle: "Foundation текстове, пренаписани от модели-учители като учебников текст; всяко число и всяко собствено име трябва да присъства в източника.",
      tbTokens: "Учебникови токени",
      tbTokensSub: "{pct} % от целта от {target}",
      tbSamples: "Приети преработки",
      tbJobs: "Завършени задачи",
      tbTeacher: "Токени на учителя на учебников токен",
      tbCost: "Цена на милион учебникови токени",
      tbCostNone: "шлюзът не съобщава цена; броят се токените на учителя",
      tbExplain: "Върви паралелно с обучението; по-късните епохи и охлаждането четат запечатаното дотогава.",
      trThroughputTitle: "Пропускателна способност (токени/s)",
      trCurriculumTitle: "Учебен план",
      trStageTokens: "{tokens} токена",
      trStageBegins: "започва от стъпка {step}",
      trPlanWarningLabel: "Внимание",
      trPlanWarning: "Изпълнението свършва след {max} стъпки в етап „{stage}“ — данните за способности започват едва от стъпка {cap}. Пълно преминаване би отнело {steps} стъпки (≈ {days} дни).",
      trPlanOk: "Планираните стъпки стигат до етап „{stage}“.",
      trCheckpointsTitle: "Checkpoints",
      trNextCheckpoint: "Следващ checkpoint",
      trInSpan: "след {span}",
      trResumes: "Възобновяване",
      trNoResume: "няма",
      trConfig: "Конфигурация",
      trHealth: "Състояние",
      trMicroBatch: "Микро-партида / токени на стъпка",
      trSeqLen: "Дължина на последователността",
      trLrPlan: "План на скоростта на обучение",
      trLrPlanValue: "пик {lr}, загряване {warmup} стъпки, косинус до стъпка {max}",
      trSpikes: "Скокове на загубата (последния час)",
      trProgressSub: "стъпка {step} от {max} · тренира от {elapsed}",
      trTokensSub: "от {planned} планирани",
      trPathTrainingDetail: "{pct} % · стъпка {step} от {max} · край около {end}",
      trReadinessRunning: "Тренирането тече: {pct} % готово (стъпка {step} от {max}), загуба {loss}, край около {end}.",
      tdvDraftsHistory: "По-стари чернови, никога не запечатани ({count})",
      runsHistory: "Прекратени и неуспешни изпълнения ({count})",
      trAxisStep: "Тренировъчна стъпка",
      trAxisLoss: "Загуба (естествен логаритъм)",
      trCountdown: "{d} д {h} ч {m} мин {s} с",
      trTimerWaiting: "Таймерът идва след първите измервания.",
      trTimerStageEnds: "Етап „{stage}“ свършва след",
      trTimerAt: "в {time}",
      trTimerNext: "След това „{stage}“: {span}, от {time}",
      trTimerRunEnds: "Изпълнението свършва след {span} (в {time})",
      trStepTimeSub: "{wall} s на стъпка измерено · изчисление {compute} s",
      trEtaTitle: "Оставащо време от измерената продължителност на стъпката",
      trEtaEpochEnds: "Епоха {epoch} от {epochs} свършва след",
      trEtaEpochAt: "в {time} (стъпка {step})",
      trEtaNextEpoch: "Епоха {epoch}: от {time} (стъпка {step})",
      trEtaDecay: "Фазата на охлаждане започва след {span} (в {time}, стъпка {step})",
      trEtaBasis: "Основа: {wall} s на стъпка, средно от последните {n} стъпки без {pauses} паузи (рестарт, застой); време за изчисление според тренера {compute} s на стъпка.",
      devTitle: "Отклонения от плана",
      devNone: "Няма отклонения — изпълнението следва плана изцяло.",
      devPlanned: "планирано",
      devLimit: "ограничение",
      devSeqLen: "Дължина на контекста",
      devSeqLenText: "Тренира се с {trained} токена контекст вместо предвидените {spec}. Дългият контекст идва в по-късна фаза.",
      devFim: "Запълване на празнини (FIM)",
      devFimText: "Целта за запълване на празнини ({rate} % от блоковете) е обявена в плана, но още не е активна в това изпълнение.",
      devTermination: "Сонда за прекратяване",
      devTerminationText: "Сондата за прекратяване не е тренировъчна цел, а отделен режим след тренирането; работи по-късно върху готов checkpoint.",
      devDecision: "Цел за решения",
      devDecisionText: "Целта за решения е активна, но в етапите след тренирането не пристигнаха маркери за решения.",
      devKernelOff: "Ускорението е изключено",
      devKernelUnverifiedText: "Ядрото „{kernel}“ не беше потвърдено от пробата и работи като стандартно изчисление.",
      devKernelUnavailableText: "Ядрото „{kernel}“ не е налично на тази карта и работи като стандартно изчисление.",
      devKernelFellBackText: "Ядрото „{kernel}“ се върна към стандартното изчисление по време на изпълнението ({reason}).",
      devOptimizer: "Оптимизатор",
      devOptimizerText: "Състоянията на оптимизатора са в bfloat16 вместо 8 бита (bitsandbytes не е наличен) — повече памет, същата математика.",
      devScale: "Размер на модела",
      devScaleText: "Моделът е инстанциран на {scale} % от размера в плана, защото пълният размер не се побра в измерената памет.",
      devMediaHeads: "Медийни глави",
      devMediaHeadsText: "Главите за изображения/аудио са нетренирани, защото данните не съдържат медийни токени — планирано за текстов клон.",
      devVision: "Визуален път",
      devVisionText: "Визуалният път е изграден, но е трениран с нула изображения, защото данните не съдържат такива.",
      devOther: "Друго",
      trStageShare: "{pct} % от този етап готови",
      cap_tool_calling: "Извиквания на инструменти",
      cap_deep_reasoning: "Дълбоко разсъждение",
      cap_software_engineering: "Разработка на софтуер",
      cap_office_finance: "Офис и финанси",
      cap_doc_understanding: "Разбиране на документи",
      tpExplainThresholds: "За всяка способност на избрания клон в data lake трябва да има достатъчно проверени примери. Целта и измерената стойност са тук за всяка способност.",
      tpThresholdsDetail: "{met} от {total} способности достигнаха целта си",
      tpThresholdRow: "{measured} примера",
      tpForeignThresholds: "Не за този клон: {list} — принадлежи на друг клон и не блокира нищо.",
      tpStepTokenizerReleaseExplain: "Токенизаторът превръща текст в числа. Фиксира се веднъж и се докладва на архитектурата, за да говорят данни и модел един език.",
      tpStepTokenizeTdvExplain: "Всички проверени примери се превеждат в числови поредици с фиксирания токенизатор.",
      tpStepTokenizeCorpusExplain: "Целият суров текст от data lake се превежда в числови поредици — масата за основата.",
      tpStepTdvCreateExplain: "От всички токенизирани данни се сглобява фиксирана версия на тренировъчните данни (TDV) с учебен план и измерен обем токени.",
      tpStepTdvSealExplain: "Версията става непроменима и се копира с описание в block storage.",
      tpStepCompatExplain: "Дванадесет правила проверяват дали версията и архитектурата си пасват (токенизатор, дължина на контекста, цели, памет). Всички трябва да са зелени.",
      tpStepVramExplain: "Измерва на картата дали има достатъчно свободна GPU памет за декларираната нужда.",
      tpVramDetail: "{free} GB свободни, {need} GB нужни",
      tpStepTrainStartExplain: "Автопилотът стартира тренировъчното изпълнение, щом всички условия са изпълнени.",
      tpStepTrainingExplain: "Изпълнението тренира самостоятелно с checkpoint на всеки 30 минути и продължава само след всяко прекъсване. Подробности на страницата „Обучение и публикуване“.",
      tpVramRunning: "картата се ползва от течащото трениране ({need} GB нужни); изпълнено при старта",
      trPathTrainingDetailNoEnd: "{pct} % · стъпка {step} от {max}",
      srTitle: "Готовност на данните по клон на модела",
      srSubtitle: "Докато един клон тренира, data lake продължава да подготвя данните на другите — до собствена запечатана версия, без старт на тренировка.",
      srTrainingNow: "тренира сега",
      srSelected: "избран",
      srDataReady: "данните са готови",
      srPreparing: "в подготовка",
      srModalities: "вход: {in} · изход: {out}",
      srThresholds: "цели: {met} от {total} достигнати",
      srCorpus: "Токенизиран корпус",
      srCorpusValue: "{tokens} токена в {shards} пакета с данни",
      srVersion: "Най-нова версия",
      srNoVersion: "още няма",
      srLacking: "Още липсва",
      srLacksNothing: "нищо — версията чака своя клон",
      srLackThresholds: "целите не са достигнати",
      srLackCodec: "кодекът за изображение/аудио не е освободен",
      srLackTokenizer: "токенизаторът не е докладван",
      srLackVersion: "няма запечатана версия",
      srSelectedNote: "Този клон тренира сега; пътят му е по-горе.",
      srSelectedIdleNote: "Този клон е избран за следващото обучение; пътят му е по-горе.",
      srUnselectedNote: "Този клон не стартира тренировка, докато е избран друг — данните му все пак се подготвят изцяло.",
      modText: "текст",
      modImage: "изображение",
      modAudio: "аудио",
      modVideo: "видео",
      tpStepThresholds: "Постигане на целите",
      tpStepPlan: "Достигане на плана за данни от статията",
      tpExplainPlan: "Статията определя колко уникални, проверени токена са нужни за всяка област. Немският и английският носят поне половината всеки; кодът се брои без език. Броят се допуснатите токени след премахване на дубликатите, а не суровата оценка.",
      tpPlanDetail: "{met} от {total} области са достигнати",
      tpPlanRowLang: "{have} / {target} · немски {de} / {half} · английски {en} / {half}",
      tpPlanRowFree: "{have} / {target}",
      tpPlanOpen: "отворено: {langs}",
      tpLangDe: "немски",
      tpLangEn: "английски",
      tpPlanProvisional: "Предварително преброено с досегашния токенизатор; решава новообученият.",
      tpStepOwnTokenizer: "Собствен токенизатор на клона",
      tpStepOwnTokenizerExplain: "Клонът се обучава със собствен токенизатор, научен върху балансиран корпус с код. Едва в неговите токени планът за данни се брои окончателно.",
      tpPlanCat_knowledge: "Знание",
      tpPlanCat_code: "Код",
      tpPlanCat_mathematics: "Математика",
      tpPlanCat_domain: "Специализирани текстове",
      tpPlanCat_textbook: "Учебник",
      tpPlanCat_agentic: "Агентни примери",
      tpPlanFlow: "приток {rate} на час",
      tpPlanEtaDays: "остават около {n} дни",
      tpPlanEtaHours: "остават около {n} часа",
      tpPlanNoFlow: "няма приток през последните 24 часа",
      tpPlanBinding: "тясно място",
      tpBind_download: "изтегляне",
      tpBind_allowance: "дневната квота на block storage",
      tpBind_ingest: "приемане",
      tpBind_teachers: "модели-учители",
      thrPlanTitle: "Примери по способност (измерени)",
      thrPlanNote: "Целите на този клон определя неговата статия: планът за данни по област, на немски и английски, в пътя до старта на обучението. Праговете по способност важат само за клонове без план за данни; тук е показано какво съдържа всяка способност според измерването.",
      thrPlanRow: "{samples} примера · {tokens} токена",
      srDataPlan: "План за данни от статията: достигнати {met} от {total} области",
      srLackDataPlan: "планът за данни не е достигнат",
      srPlanOpen: "отворено: {areas}",
      tpBind_source: "няма източник на този език",
      tpBind_paused: "изтеглянето е на пауза",
      tdvPlanEmpty: "Все още няма версия на данните за активната спецификация. Автопилотът я изгражда и запечатва, щом планът за данни от статията бъде достигнат.",
      compatPlanNone: "Все още няма проверка: версията на активната спецификация се проверява, когато бъде запечатана.",
      mixPlanTitle: "Смес според статията",
      mixPlanNote: "Всяка стъпка на обучение тегли областите в тези фиксирани дялове; фазата на затихване вдига висококачествения дял до половината. Целите за смес по способност важат само за клонове без план за данни.",
      mixPlanShare: "{area} {pct} %",
      sitTitle: "Обстановка",
      sitSubtitle: "Къде е обучението с един поглед: какво още липсва във всяка област на статията, какво тече сега и какво следва.",
      sitHeadlineDays: "Обучението може да започне най-рано след около {time}; най-дълго отнема {area} (тясно място: {bottleneck}).",
      sitHeadlineBlocked: "Така планът за данни не се достига: {items} няма източник. Работи се по това: търсене на отворени набори от данни или проверен превод.",
      sitHeadlineReached: "Планът за данни е достигнат; следват токенизаторът, новата токенизация, запечатването и проверките.",
      sitHeadlineUnknown: "Притокът на останалото още не е измерен.",
      sitHold: "Стартът е допълнително спрян, докато всеки градивен елемент бъде проверен.",
      sitArea: "Област",
      sitTotal: "Общо",
      sitFlow: "Приток",
      sitLeft: "Остава",
      sitBottleneck: "Тясно място",
      sitNoLanguage: "без език",
      sitNoSource: "няма източник",
      sitReached: "достигнато",
      sitDays: "{n} дни",
      sitHours: "{n} ч",
      sitPerHour: "{value} на час",
      sitPerHourTokens: "{value} токена на час",
      sitRunningTitle: "Какво тече сега",
      sitDownloads: "Изтегляния",
      sitIngest: "Обработка в текстови откъси",
      sitTokenize: "Токенизация",
      sitGenerate: "Генериране от модели-учители",
      sitIdle: "в покой",
      sitNextTitle: "Какво следва",
      sitNextSteps: "Обучение на токенизатора с код → нова токенизация на целия корпус → запечатване на версията → проверки → старт на обучението",
      sitProvisional: "Количествата са преброени предварително с досегашния токенизатор; окончателно брои новообученият.",
      tpPlanSeeSituation: "Областите, езиците и оставащото време са в обстановката по-горе.",
      sitHeadlineBlocks: "Обучението още не може да започне: липсват градивни елементи, които тепърва трябва да се изградят ({items}). Междувременно данните растат.",
      sitDuration: "Продължителност на обучението: около {days} дни за {budget} токена при измерени {rate} токена в секунда на същата мрежа.",
      sitBlocksTitle: "Градивни елементи на обучението",
      sitStateNotBuilt: "още не е изградено",
      sitStateWaiting: "чака",
      sitStateReady: "готово",
      sitBlockWaitsFor: "чака: {items}",
      sitBenchProgress: "{made} от {total} проверени задачи",
      sitBlockParts: "изградено: {built} · отворено: {open}",
      part_graph_bundles: "свързани документи",
      part_repository_bundles: "цели хранилища",
      part_long_context: "дълъг контекст",
      part_fine_tuning: "фино настройване",
      part_reinforcement_learning: "обучение с подкрепление",
      part_real_folding: "истинско сгъване на контекста",
      sitBlock_data: "Данни според плана на статията",
      sitBlock_tokenizer: "Токенизатор с код",
      sitBlock_bench: "Бенчмарк пакет на статията",
      sitBlock_trainer: "Обучител: стъпки на прозореца, фиксиран бюджет, фиксирана смес",
      sitBlock_bundles: "Пакети: свързани документи и цели хранилища",
      sitBlock_post_training: "Дообучение: дълъг контекст, фина настройка, обучение с награди",
      tpStepTokenizerRelease: "Освобождаване на токенизатора",
      tpStepTokenizeTdv: "Токенизиране на обучителните примери",
      tpStepTokenizeCorpus: "Токенизиране на корпуса",
      tpStepTdvCreate: "Създаване на версия на данните",
      tpStepTdvSeal: "Запечатване на версията на данните",
      apAfterSealLabel: "Автоматично продължаване след запечатването",
      apAfterSealOn: "ВКЛ",
      apAfterSealOff: "ИЗКЛ",
      apAfterSealConfirmOn: "Автоматично продължаване след запечатването? Пътят до старта на обучението продължава без пауза: проверка за съвместимост, проверки на GPU и старт на обучението.",
      apAfterSealConfirmOff: "Отново спиране след запечатването? Автопилотът тогава спира на пауза за преглед след запечатването на версията на данните.",
      apAfterSealTurnedOn: "Пътят до старта на обучението продължава автоматично след запечатването.",
      apAfterSealTurnedOff: "Автопилотът спира след запечатването.",
      apAfterSealWaiting: "Версията на данните е запечатана – автопилотът е на пауза за преглед.",
      apAfterSealStep: "Преглед на запечатаната версия на данните",
      apAfterSealHint: "След запечатването всички данни са обработени в блоковото хранилище. При изключен превключвател автопилотът спира там за преглед; при включен пътят продължава автоматично.",
      tpStepCompat: "Проверка за съвместимост",
      tpStepVram: "VRAM проба",
      tpStepTrainStart: "Старт на обучението",
      tpStepTraining: "Обучението тече",
      apSubtitle: "Един превключвател за целия цикъл: събиране, обработка и свързване на данни, генериране на примери, обучение щом планът за данни от статията е достигнат, бенчмарк и частно публикуване. Всяко блокиране се назовава, вместо да се прикрива.",
      apOn: "Автопилот ВКЛ",
      apOff: "Автопилот ИЗКЛ",
      apTurnOn: "Включи автопилота",
      apTurnOff: "Изключи автопилота",
      apConfirmOn: "Включване на автопилота? Той попълва данните непрекъснато до запечатаната версия на данните; след това спира за преглед, освен ако „Автоматично продължаване след запечатването“ е включено.",
      apConfirmOff: "Да изключа ли автопилота? Текущата работа завършва контролирано; нищо не се изхвърля.",
      apEnabled: "Автопилотът е включен",
      apDisabled: "Автопилотът е изключен",
      apPause: "Пауза",
      apResume: "Продължи",
      apResumed: "Автопилотът е продължен",
      apPausedNote: "Автопилотът е на пауза",
      apPausedPill: "на пауза",
      apPhaseLabel: "Фаза",
      apPhaseSince: "от {time}",
      apCycleId: "Цикъл",
      apBlockedLabel: "Блокирано",
      apCycleTitle: "Напредък на текущия цикъл",
      apCycleEmpty: "Няма активен цикъл.",
      colPhase: "Фаза",
      colPending: "Чака",
      colRunning: "Изпълнява се",
      colDone: "Готово",
      colFailed: "Неуспешно",
      thrTitle: "Прагове по способности",
      thrSubtitle: "От тези обеми автопилотът запечатва версия на обучителните данни и стартира обучението; лентите показват измерения напредък.",
      thrMet: "достигнат",
      thrNotMet: "отворен",
      thrDefault: "предварително зададен стандарт",
      thrForeign: 'не за избраното направление',
      staleSince: 'Работникът не отговаря в момента — последно измерено състояние от',
      staleHint: 'Автопилотът продължава; изгледът се обновява щом работникът отговори отново.',
      idxTitle: 'Векторен индекс и дедупликация',
      idxSubtitle: 'Собственият HNSW индекс на езерото за свързване на графа и измереното премахване на дублирани chunk-шардове.',
      idxConfigured: 'Индекс конфигуриран',
      idxReachable: 'Индекс достъпен',
      idxPoints: 'Точки в индекса',
      idxBackfill: 'Попълване от таблицата с embeddings',
      idxBackfillDone: 'завършено',
      idxBackfillOpen: 'тече / отворено',
      ddLastPass: 'Последен дедуп-проход',
      ddChecked: 'проверени активи',
      ddDropped: 'премахнати дублирани шардове',
      ddRows: 'премахнати chunk-редове',
      ddRemaining: 'оставащи кандидати',
      ddNone: 'още няма проход',
      gsTitle: 'Етапи на графа',
      gsSubtitle: 'Teacher-етапите на графа — embedding и извличане на твърдения — служат на синтеза на примери от графа; затова вземат chunk-ове в ширина през активите, по ред на ранговете: ранг 0 документите на собственика и импортите от инструменти, ранг 1 експертното знание (наука, техника, книги, разсъждение, German Commons, Wikipedia), ранг 2 общ текст (Wikisource, Gutenberg, уеб корпуси, транскрипции), ранг 3 код (само embedding, никога извличане на твърдения). Базовата маса стига до корпуса от токени без teacher-проход.',
      gsMeasuredAt: 'Измерено в',
      gsRanksTitle: 'Ред на ранговете',
      gsRanksEmpty: 'Още няма докладван план на ранговете.',
      gsColRank: 'Ранг',
      gsColLabel: 'Клас източник',
      gsColSources: 'Източници',
      gsColAssets: 'Активи',
      gsColPendingExtract: 'Чака извличане',
      gsColPendingEmbed: 'Чака embedding',
      gsRankOwner: 'Документи на собственика и импорти от инструменти',
      gsRankExpert: 'Експертно знание',
      gsRankGeneral: 'Общ текст',
      gsRankCode: 'Код (само embedding)',
      gsRankShort: 'ранг {n}',
      gsLoopsTitle: 'Последен кръг на всеки цикъл',
      gsColLoop: 'Цикъл',
      gsColSource: 'Източник',
      gsColChunks: 'Обработени chunk-ове',
      gsColClaims: 'Твърдения',
      gsColEdges: 'Ребра',
      gsColSeconds: 'Секунди',
      gsColLast: 'Последен кръг',
      gsLoopEmbed: 'Embedding',
      gsLoopExtract: 'Извличане на твърдения',
      gsLoopLink: 'Свързване',
      gsUngrounded: '{n} без основание',
      gsNoRound: 'още няма кръг',
      gsClaims: 'Твърдения общо',
      gsAssetsWithClaims: 'Активи с твърдения',
      gsDangling: 'Осиротели chunk-възли',
      gsStuck: 'Заседнали активи (в обработка без работещ ingest)',
      gsConcurrency: 'Паралелност на извличането',
      gsOrphansLast: 'Последен проход за почистване',
      gsOrphansNone: 'още няма проход',
      gsOrphansStatusCleaned: 'почистено',
      gsOrphansDropped: 'премахнати възли',
      gsOrphansRemaining: 'оставащи',
      gsOrphansHint: 'Тук няма какво да се прави: автопилотът сам планира ограничен проход за почистване, докато съществуват chunk-възли без шард. Обобщението показва последния проход.',
      thrSamplesBar: "Примери",
      thrTokensBar: "Токени (оценка)",
      thrNoMinimum: "измерено, без минимум",
      thrEditTitle: "Редактирай праговете",
      thrEditSubtitle: "Записът заменя всички прагове изцяло; предварително зададените стандарти важат само докато тук не бъдат зададени собствени стойности.",
      thrMinSamples: "Мин. примери",
      thrMinTokens: "Мин. токени (оценка)",
      thrEnabled: "активен",
      thrAdd: "Добави ред",
      thrSave: "Запази праговете",
      thrSaved: "Праговете са запазени",
      thrEmpty: "Още няма дефинирани прагове — без активни прагове автопилотът не запечатва нищо и съобщава това като блокиране.",
      capability: "Способност",
      modSignature: "Сигнатура",
      removeRow: "Премахни",
      budgetsTitle: "Дневни бюджети",
      budgetsSubtitle: "Разход срещу лимит по област и ден — бюджетите ограничават извикванията на учителя и на embedding.",
      budgetScope: "Област",
      budgetDay: "Ден",
      budgetSpent: "Изразходвано",
      budgetCap: "Лимит",
      budgetsEmpty: "Няма съобщени бюджети.",
      eventsTitle: "Събития",
      eventsSubtitle: "Какво автопилотът последно направи или съобщи, най-новото първо.",
      eventsEmpty: "Още няма събития.",
      storageTitle: "Облачно хранилище",
      storageSubtitle: "Връзката с Block Storage и инициализацията на структурата от папки — повторима без странични ефекти.",
      connect: "Свържи Block Storage",
      backendLabel: "Backend на студеното хранилище",
      backendBlockStorage: "Block Storage",
      backendLocal: "Локално хранилище",
      connectedLabel: "Връзка",
      connectedYes: "свързано",
      connectedNo: "несвързано",
      accountLabel: "Акаунт",
      signinValidUntil: "Входът е валиден до",
      oauthClientLabel: "OAuth клиент",
      clientConfigured: "конфигуриран",
      clientNotConfigured: "неконфигуриран",
      bootstrapRun: "Инициализирай структурата",
      bootstrapDone: "Инициализацията е изпълнена",
      bootstrapReportTitle: "Последно изпълнение",
      bootstrapNoRun: "В тази сесия още не е изпълняван bootstrap.",
      bootstrapLine: "Създадени папки: {folders} · файлове в студеното хранилище: {files} · повторение без промени: {idempotent}",
      treeTitle: "Дърво от папки",
      treeSubtitle: "Дървото е версионирана спецификация: тук дефинирате папки, автопилотът може само да добавя. Защитените папки на двигателя и непразните папки двигателят отказва с основание. В Block Storage се изтрива само по твърди правила, например по-старите копия на checkpoint (двете най-нови остават); по време на пълно изтегляне изтриванията и презаписванията чакат, докато то приключи.",
      treeActiveVersion: "Активна версия v{version}",
      treePath: "Път",
      treePurpose: "Предназначение",
      treeCreatedBy: "Създадено от",
      treeShards: "Шардове",
      treeBytes: "Размер",
      treeActions: "Действия",
      treeRetire: "Изведи от употреба",
      treeRetired: "Папката е изведена от употреба",
      treeAddFolder: "Добави папка",
      treeFolderAdded: "Папката е създадена",
      treeVersionsTitle: "Версии",
      treeEmpty: "Още няма дефинирани папки.",
      treePlanned: "Планирано — спецификация на дървото v{version}",
      treeFiles: "Файлове",
      treeSizesMeasured: "Размерите са измерени {measured}; папките, които каталогът не води, са преброени в Block Storage за последно {walked}. 1 GB = 10⁹ байта.",
      treeSizesNoWalk: "Размерите са измерени {measured}; папките, които каталогът не води, още не са преброени. 1 GB = 10⁹ байта.",
      treeExpand: "Покажи подпапките ({count})",
      treeCollapse: "Скрий подпапките",
      treeShowMore: "Покажи още папки ({count})",
      treeSourceCatalog: "От каталога: броят се обектите, които наистина са в Block Storage",
      treeSourceWalk: "Преброено при обхождането на Block Storage",
      bsUsageTitle: "Място в Block Storage",
      bsUsageSubtitle: "Заето място, лимит и свободно място на акаунта в Block Storage и делът на data lake в него; стойностите са най-много на десет минути. 1 GB = 10⁹ байта.",
      bsUsed: "Заето",
      bsLimit: "Лимит",
      bsFree: "Свободно",
      bsNoLimit: "без фиксиран лимит",
      bsTrash: "В кошчето",
      bsLake: "От тях data lake",
      bsLakeLine: "{size}, файлове: {files} · {share} от заетото място",
      bsMeasuredAt: "Измерено",
      bsNotConnected: "Block Storage не е свързан; мястото ще се появи веднага щом има връзка.",
      bsBarLake: "Data lake",
      bsBarOther: "Останалото в акаунта",
      bsDlTitle: "Пълно изтегляне",
      bsDlSubtitle: "Изтегля целия Block Storage файл по файл в същата структура от папки, без архив. Докато тече, важи защитният режим: изтриванията и презаписванията на обхванатите файлове чакат, докато приключи; новите файлове продължават да се записват и не са част от това изтегляне. Текущо обучение никога не се забавя.",
      bsDlButton: "Изтегли целия Block Storage",
      bsDlFolderHint: "Избирате веднъж целева папка; подпапките се създават там. Вече пълните файлове се пропускат, прекъснатите продължават от дължината си.",
      bsDlScriptHint: "Този браузър не може да записва папки. Получавате скрипт за изтегляне, който създава същата структура от папки и изтегля всеки файл с възможност за продължаване.",
      bsDlWindowsNames: "Знаците, които Windows не позволява в имена (например „>“), стоят в целевата папка като %-код, например %3E.",
      bsDlActiveNote: "Изтегляне тече от {time}. Бутонът горе го продължава в този браузър; пълните файлове се пропускат.",
      bsDlBuilding: "Списъкът с файлове се създава: досега файлове: {files}, {size}.",
      bsDlManifest: "Списъкът с файлове се зарежда: {done} от {total} записа.",
      bsDlFolder: "Целева папка",
      bsDlFiles: "Файлове",
      bsDlData: "Данни",
      bsDlOf: "{done} от {total}",
      bsDlRate: "Скорост",
      bsDlEta: "Оставащо време",
      bsDlEtaUnknown: "изчислява се",
      bsDlCurrent: "Изтегля се сега",
      bsDlSkipped: "Вече пълни, пропуснати: {count}",
      bsDlFailed: "Неуспешни файлове: {count}",
      bsDlPausedNote: "На пауза. При продължаване започнатите файлове се изтеглят нататък от дължината си; защитният режим остава, докато тази страница е отворена.",
      bsDlPause: "Пауза",
      bsDlContinue: "Продължи",
      bsDlRetryFailed: "Изтегли неуспешните отново",
      bsDlFinish: "Приключи",
      bsDlStop: "Спри",
      bsDlStateBuilding: "списъкът с файлове се подготвя",
      bsDlStateRunning: "изтегля",
      bsDlStatePaused: "на пауза",
      bsDlStateIncomplete: "непълно",
      bsDlStateScript: "скриптът е готов",
      bsDlStateFinished: "приключено",
      bsDlStateStopped: "прекратено",
      bsDlStateActive: "активно",
      bsDlFinished: "Всички файлове ({files}, {size}) са в целевата папка; изтеглянето е приключено.",
      bsDlFinishedNote: "Изтеглянето е приключено; задържаните изтривания и презаписвания се изпълняват сега.",
      bsDlStopped: "Изтеглянето е спряно; задържаните изтривания и презаписвания се изпълняват сега. Вече изтеглените файлове остават.",
      bsDlEnded: "Сървърът прекрати изтеглянето, например след трийсет минути без признак на живот. Ново щракване го стартира отново; пълните файлове се пропускат.",
      bsDlSession: "Входът е изтекъл. Влезте отново; след това бутонът горе продължава изтеглянето.",
      bsDlDiskFull: "В целевата папка няма повече място. Освободете място и продължете.",
      bsDlPickFailed: "Целевата папка не можа да се отвори.",
      bsDlScriptPosix: "Скрипт за Linux и macOS",
      bsDlScriptWindows: "Скрипт за Windows",
      bsDlScriptRun: "Запазете скрипта в целевата папка и го стартирайте там: в Windows с двойно щракване върху файла .cmd или от командния ред, в Linux и macOS в терминал с „sh <файл>“.",
      bsDlScriptKeyValid: "Ключът в скрипта е валиден до {time}, само за това изтегляне и само за четене.",
      bsDlScriptHeartbeat: "Докато тази страница е отворена, тя съобщава на сървъра, че изтеглянето още тече. Когато скриптът приключи, щракнете „Приключи“.",
      bsDlProtection: "Защитен режим",
      bsDlProtectionState: "Състояние",
      bsDlProtectionOn: "активен от {time}",
      bsDlProtectionOff: "неактивен",
      bsDlScope: "Обхват на изтеглянето",
      bsDlScopeValue: "файлове: {files}, {size}",
      bsDlDeferredDeletes: "Задържани изтривания",
      bsDlDeferredOverwrites: "Задържани презаписвания",
      bsDlAddedSince: "Добавени от старта",
      bsDlLastActivity: "Последен признак на живот",
      acqTitle: "Източници на данни",
      acqSubtitle: "Курирани източници с отворен лиценз: за всеки — лиценз, оценка на защитата на данните, език, модалност, байтова цел и измерен напредък. Изключените източници назовават причината си, вместо тихо да липсват.",
      acqGdprNote: "Принцип на GDPR: обучителни данни се допускат само от източници с отворен лиценз и документирана оценка на защитата на данните; данните от входящите минават PII почистване преди създаването на примери (броячът „PII почистени“ го показва).",
      acqSource: "Източник",
      acqModality: "Модалност · език",
      acqLicense: "Лиценз",
      acqProtection: "Защита на данните",
      acqProgress: "Напредък",
      acqDocs: "{count} файла/обекта получени",
      acqTargetReached: "целта е достигната",
      acqExhausted: "източникът е изчерпан (листингът не предоставя нищо повече)",
      acqEnabledPill: "активен",
      acqWaitingBuffer: "изчаква: буферът е пълен, качването наваксва",
      acqDisabledPill: "изключен",
      acqEnable: "Включи",
      acqDisable: "Изключи",
      acqEnabledMsg: "Източникът е включен",
      acqDisabledMsg: "Източникът е изключен",
      acqTargetLabel: "Цел (ГБ)",
      acqSetTarget: "Запази целта",
      acqTargetSaved: "Целта е запазена",
      acqEmpty: "Още няма регистрирани източници.",
      balanceTitle: "Езиков баланс немски/английски",
      balanceSubtitle: "Изтеглени байтове по модалност и език — при началните източници немският не бива да изостава от английския.",
      balanceEmpty: "Още няма измервания.",
      modText: "Текст",
      modAudio: "Аудио",
      modImage: "Изображение",
      modVideo: "Видео",
      prepTitle: "Предварителна обработка",
      prepSubtitle: "Преброени етапи на конвейера от регистрирания суров документ до обучителния пример — всяко число от каталога; грешките и неподдържаното са назовани.",
      prepRegistered: "регистрирани",
      prepScrubbed: "PII почистени",
      prepChunked: "разделени",
      prepEmbedded: "вградени",
      prepExtracted: "извлечени",
      prepLinked: "свързани",
      prepSamples: "примери",
      prepByLang: "По език",
      prepUnsupported: "Неподдържано",
      prepAwaiting: "Чака етап",
      prepFailures: "Грешки",
      inboxTitle: "Входящи сурови данни",
      assetWhat: "Съдържание",
      assetFromSource: "от източник {source}",
      assetFromUpload: "качено ръчно",
      mediaParquet: "Таблични данни (Parquet)",
      treeShardsHint: "Шардовете са Parquet-пакетите с данни на каталога: всеки ред е пакет с произход, език и цел — колоната „цел“ казва какво има в папката.",
      mediaWords: {
        text: "Текст",
        audio: "Аудио",
        video: "Видео",
        image: "Изображение",
        application: "Файл",
      },
      inboxSubtitle: "Предайте собствени сурови данни на lake: качете тук или ги поставете направо в облачната папка raw/inbox/. Съгласуването регистрира всеки файл; „Обработи сега“ стартира същия път, по който автопилотът върви сам.",
      uploadButton: "Качи файл",
      uploadHint: "До 512 МБ на файл. Каченото попада в студеното хранилище и при обработка се разделя, вгражда и свързва в графа на знанието.",
      uploadTooLarge: "Файлът е по-голям от 512 МБ.",
      uploadDone: "Файлът е приет",
      processNow: "Обработи сега",
      processStarted: "Обработката е стартирана",
      reconcileNow: "Съгласувай облачната папка",
      reconcileDone: "Съгласуването е изпълнено",
      unprocessedCount: "{count} необработени",
      inboxEmpty: "Входящите са празни.",
      assetName: "Файл",
      assetType: "Тип",
      assetSize: "Размер",
      assetState: "Състояние",
      assetLang: "Език",
      assetRegistered: "Регистрирано",
      assetStates: {
        raw_stored: "суровите данни са запазени",
        awaiting_stt: "изчаква разпознаване на реч",
        awaiting_content_fetch: "чака съдържанието зад адреса",
        awaiting_image_codec: "изчаква кодека за изображения",
        awaiting_audio_codec: "изчаква аудио кодека",
        awaiting_video_codec: "изчаква видео кодека",
        chunked: "нарязано и в графа",
        processed: "обработен",
        registered: "регистриран",
        queued: "чака",
        processing: "в обработка",
        ingested: "приет",
        linked: "свързан",
        unsupported: "неподдържан",
        failed: "неуспешен",
      },
      graphTitle: "Граф на знанието",
      graphSubtitle: "Свързаният суров корпус: възли и ребра, преброени от каталога — от тези връзки възникват обучителните примери.",
      graphEmbedded: "Вградени възли",
      graphModel: "Embedding модел",
      graphClusters: "Клъстери",
      graphAssetsLinked: "Свързани сурови данни",
      graphLastLink: "Последно свързване",
      graphNodesTitle: "Възли по вид",
      graphEdgesTitle: "Ребра по вид",
      graphEmpty: "Графът е още празен — той възниква с първия обработен файл.",
      kindCol: "Вид",
      countCol: "Брой",
      neighborsTitle: "Съседи на възел",
      nodeIdLabel: "ID на възела",
      neighborsRun: "Вземи съседите",
      neighborsEmpty: "Не са намерени съседи.",
      nodeCol: "Възел",
      edgeKindCol: "Ребро",
      weightCol: "Тегло",
      gapTitle: "Матрица на покритие и пропуски",
      gapSubtitle: "Измерен фонд спрямо зададените цели за смесване по способност, сигнатура и ниво — SQL изглед върху каталога, никога твърдо заложен.",
      tier: "Ниво",
      gapHave: "Налично",
      gapTarget: "Цел",
      gapWeight: "Тежест",
      gapPriority: "Приоритет",
      targetsTitle: "Задай цели за смесване",
      targetsSubtitle: "Целите носят автор и момент; без цели матрицата честно показва празното състояние.",
      addTargetRow: "Добави ред",
      saveTargets: "Запази целите",
      targetsSaved: "Целите са запазени",
      statusCol: "Статус",
      tdvTitle: "Запечатано състояние на данните",
      tdvSubtitle: "Състоянието на данните е непроменимо и съставено от запечатани шардове; новото заменя предишното.",
      createTdv: "Създай чернова на TDV",
      tdvCreated: "Черновата на TDV е създадена",
      tdvId: "TDV",
      tdvName: "Име",
      tdvMembers: "Съставни части",
      tdvCreatedAt: "Създадена",
      tdvSealedAt: "Запечатана",
      tdvStatusDraft: "чернова",
      tdvStatusSealed: "запечатана",
      sealTdv: "Запечатай",
      tdvSealed: "TDV е запечатана",
      tdvEmpty: "Още няма Train Data Version — тя се съставя от запечатани шардове.",
      compatTitle: "Проверка на съвместимостта между архитектура и данни",
      compatSubtitle: "Правила R1–R12 върху два машинночетими документа; таблото показва записания доклад на двигателя и не изчислява собствена присъда.",
      compatAllGreen: "ALL-GREEN",
      compatNotGreen: "не е ALL-GREEN",
      compatRun: "Изпълни проверка",
      compatChecked: "Проверката е изпълнена",
      compatSelectTdv: "Изберете TDV от списъка по-горе, за да видите нейния доклад.",
      compatNoReport: "За тази TDV още няма записан доклад за съвместимост.",
      compatDraftNote: "Интерфейсът на данните на архитектурата е чернова — артефактите на токенизатора и кодеците още не съществуват; проверката се задейства с първото издание на токенизатора и първата запечатана TDV.",
      compatRule: "Правило",
      compatTitleCol: "Заглавие",
      compatKind: "Вид",
      compatEvidence: "Сравнени стойности (доказателство)",
      kindHard: "твърдо",
      kindWarn: "предупреждение",
      reportsTitle: "Записани доклади",
      reportsEmpty: "Още няма записан доклад за съвместимост.",
      phaseLabel: "Фаза на обучение",
      phaseA: "Фаза A — готовност и еволюция",
      phaseB: "Фаза B — обучението тече, архитектурата е замразена",
      checklistTitle: "Готовност за обучение (контролен списък на фаза A)",
      checklistSubtitle: "Условията се изчисляват на живо; стартът остава блокиран, докато всяка точка стане зелена, а всяка неизпълнена точка е назована.",
      checklistReady: "готово",
      checklistUnmet: "неизпълнени точки: {count}",
      checklistUnavailable: "Контролният списък е недостъпен.",
      itemSatisfied: "изпълнено",
      itemUnsatisfied: "неизпълнено",
      startTraining: "Стартирай фаза B",
      strandTitle: 'Обучаван клон',
      strandSubtitle: 'Кой клон на модела се обучава, щом всички условия са изпълнени; неизбраният клон продължава да подготвя данни, но никога не стартира.',
      strandSelectedBadge: 'избран',
      strandExplain: 'Автопилотът обучава {selected}. {other} продължава да събира и подготвя, но не стартира, докато не бъде избран.',
      strandSwitched: 'Изборът е запазен.',
      strandSwitchFailed: 'Превключването не успя.',
      strandUnavailable: 'Този бекенд още не предоставя клонове; изборът ще се появи след следващото внедряване на ядрото.',
      trainingStarted: "Фаза B е стартирана",
      startBlocked: "Стартът е блокиран — неизпълнено: {items}",
      selectedTdvLabel: "Избрано състояние на данните",
      computedAt: "Изчислено",
      runsTitle: "Обучителни изпълнения",
      runsSubtitle: "Само реални изпълнения от каталога; симулиран обучителен процес не съществува.",
      runId: "Изпълнение",
      archVersion: "Архитектура",
      presetCol: "Пресет",
      seqLenCol: "Дължина на последователността",
      stepCol: "Стъпка",
      lossCol: "Loss",
      runStarted: "Започнато",
      runFinished: "Приключено",
      runsEmpty: "Още няма обучително изпълнение.",
      abortRun: "Прекрати",
      confirmAbort: "Да прекратя ли това обучително изпълнение?",
      runAborted: "Поискано е прекратяване",
      benchLink: "Бенчмарк",
      benchTitle: "Бенчмарк отчети",
      benchSubtitle: "Замразеният, версиониран пакет се изпълнява автоматично след всяко обучение; всеки отчет лежи в lake и се показва тук.",
      benchEmpty: "Още няма бенчмарк отчет.",
      suiteVersion: "Пакет",
      benchOpen: "Отвори",
      benchReportFor: "Бенчмарк отчет за изпълнение {run}",
      benchNoMarkdown: "Този отчет не носи рендериран документ; суровите резултати са по-долу.",
      exportsTitle: "Експорти",
      exportsSubtitle: "Изтегляния съществуват единствено за експорти на завършени реални обучителни изпълнения.",
      exportId: "Експорт",
      exportSize: "Размер",
      exportSha: "SHA-256",
      download: "Изтегли",
      exportsEmpty: "Още няма експорт — той възниква едва от завършено реално обучително изпълнение.",
      hfTitle: "Публикации в HuggingFace",
      hfSubtitle: "Всяко качване е частно; видимостта се проверява през API след качването. Нечастен резултат е състояние на грешка, което спира цикъла.",
      hfEmpty: "Още няма публикация.",
      hfRepo: "Хранилище",
      hfState: "Състояние",
      hfVisibility: "Видимост",
      hfPrivateVerified: "частно — проверено",
      hfUnverified: "още непроверено",
      hfVerifiedAt: "Проверено",
      connectTitle: "Свързване на Block Storage",
      connectSubtitle: "Вход през прозореца за вход на доставчика на хранилището; хранилището се свързва с акаунта, който потвърди.",
      webConnectStart: "Свързване с доставчика на хранилището",
      webConnectWaiting: "Изчакване на потвърждението в прозореца за вход на доставчика на хранилището…",
      webConnectHint: "След потвърждението хранилището се свързва автоматично; диалогът се обновява сам.",
      publicIdentity: "Публична идентичност на приложение (rclone, споделена квота)",
      publicIdentityNote: "Прозорецът за вход на доставчика на хранилището показва „rclone“ като заявяващо приложение — публично споделената идентичност; собствен client ID (GDRIVE_OAUTH_CLIENT_ID) я заменя по всяко време.",
      manualHint: "След потвърждението браузърът показва недостъпна localhost страница. Копирайте стойността на параметъра code= от адресния ред и я поставете тук (може и целият адрес).",
      manualCodeLabel: "Код за упълномощаване",
      manualSubmit: "Използване на кода",
      deviceInstead: "Вместо това използвайте код за устройство",
      licenseAcceptLink: "Потвърдете лиценза в Hugging Face",
      deviceFlowTitle: "Свържи Block Storage (device flow)",
      deviceFlowSubtitle: "Двигателят стартира потока за вход на доставчика за устройства; потвърждението става на второ устройство и се допитва на ограничени интервали.",
      deviceFlowStart: "Стартирай потока за вход",
      deviceFlowCode: "Код на устройството",
      deviceFlowOpenUrl: "Отвори страницата за потвърждение",
      deviceFlowWaiting: "Изчакване на потвърждение — допитването следва интервала, предписан от доставчика.",
      deviceFlowAuthorized: "Свързано",
      deviceFlowExpired: "Кодът на устройството е изтекъл — стартирайте потока за вход отново.",
      readinessTitle: "Готовност за обучение",
      readinessSubtitle: "Измереният път до първото обучение, етап по етап.",
      readinessCounter: "{green} от {total} изпълнени",
      readinessReady: "Готово за обучение",
      unblockLabel: "Следваща стъпка",
      readinessUnavailable: "Прегледът на готовността още не е наличен в бекенда. Щом крайната точка заработи, тук ще се появи измереното състояние.",
      stageStates: {
        ok: "изпълнен",
        active: "в ход",
        waiting: "изчаква",
        blocked: "блокиран",
      },
    },
    gt: {
      loading: '…',
      unavailable: 'недостъпно',
      equilibrium: 'Постигнато е оптимално оперативно състояние: на всички запитвания е отговорено, всички предавания на задачи са обработени и дублирането е избегнато.',
      standby: 'в готовност',
      defTitle: 'Оперативна Координация на Екипа и Показатели за Ефективност',
      defSubtitle: 'Измерване на оперативното качество на комуникация и предаване на задачи на всички AI роли: фокус върху верифицирани резултати вместо непродуктивна активност.',
      defPlayers: 'Участващи Роли и Системи',
      defPlayersText: 'Десетте специализирани AI роли с техните Webex ботове, както и хората, вземащи решения, които задават задачите и управленските насоки.',
      defStrategies: 'Принципи на Комуникация и Работа',
      defStrategiesText: 'Директен отговор на въпроси, еднозначно и пълно предаване на задачи, избягване на дублиране и последователно приключване на отворените работни пакети.',
      defPayoff: 'Нетен Оперативен Принос (Нетна Полезност)',
      defPayoffText: 'Завършени работни пакети, успешно обработени предавания и отговорени запитвания — минус загубите от триене (дублиране, необработени предавания, запитвания без отговор).',
      defEquilibrium: 'Оптимално Оперативно Състояние (Координационно Равновесие)',
      defEquilibriumText: 'Целево състояние на сътрудничество: всяко запитване получава навременен отговор, всяко предаване на задача се поема, никаква информация не се изпраща двукратно и никой работен пакет не остава блокиран.',
      playersTitle: 'Преглед на Изпълнението по Роли (Позиции)',
      playersSubtitle: 'Оперативни показатели за комуникация и доставка по роли: експертни приноси и предавания (последни 7 дни), както и срещи и завършени работни пакети (последни 30 дни).',
      playersHint: 'Нетна полезност = 3 × завършени работни пакети + обработени предавания − загуби от триене (необработените предавания се броят двойно). Отрицателна стойност показва нужда от координация.',
      player: 'Роля / Позиция',
      contributions: 'Публикации',
      meetingTurns: 'Срещи',
      handovers: 'Предавания',
      consumedShort: 'обработени',
      refusedShort: 'отказани',
      delivery: 'Доставка',
      pausedTurns: 'Паузирани ходове',
      pausedTurnsHint: 'Ходове, запазени в собствената пощенска кутия на колегата, защото моделите не са могли да ги обслужат тогава. Не са предавания.',
      closedOpen: 'приключени / отворени',
      noise: 'Загуба от триене',
      utility: 'Нетен принос',
      meetingsLine: '{held} срещи, {turns} изказвания, {u} обръщения без отговор (30 дни).',
      interactionsTitle: 'Предаване на Задачи между Роли (Handover Матрица)',
      interactionsSubtitle: 'Насочени предавания на задачи между пощенските кутии (последни 7 дни): брой, време за доставка, както и обработени и отказани предавания.',
      interactionsHint: 'Предаването на задача се счита за приключено едва след обработка от получателя; отказаните или необработени предавания се отчитат като процесни отклонения.',
      interactionsEmpty: 'Няма предавания в прозореца.',
      from: 'От',
      to: 'До',
      messages: 'Съобщения',
      consumed: 'обработени',
      refused: 'отказани',
      deviationsTitle: 'Процесни Отклонения и Активни Тесни Места',
      deviationsSubtitle: 'Текущи координационни пропуски: запитвания без отговор, необработени предавания на задачи, дублиращи се изказвания или блокирани работни пакети.',
      dev_unanswered_question: 'Запитване без отговор (изтекъл лимит за време)',
      dev_dead_air: 'Предаване на задача без обратна връзка',
      dev_repetition: 'Повторение в срещата',
      dev_meeting_unanswered: 'Директно запитване без отговор',
      dev_work_blocked: 'Работата е блокирана',
      dev_handover_hop_budget_reached: 'Достигнат лимит на прехвърлянията',
      dev_commitment_unkept: 'Неизпълнен ангажимент за спринта',
      devWithheld: 'задържано',
      devRepetition: 'повторение',
      devDeadAir: 'необработено предаване',
      devMeetingUnanswered: 'без отговор',
      effectiveThresholdCol: 'Праг',
      excessHopsLabel: 'излишни прехвърляния',
      timeTitle: 'Време на Цикъла и Сравнение на Производителността (AI спрямо ръчна работа)',
      timeSubtitle: 'Измерена продължителност на AI обработката на завършени развойни задачи спрямо прогнозния ръчен труд.',
      timeHint: 'Референтни разчетни стойности за оценка на трудоемкостта; конфигурират се от ръководството.',
      avgCycle: 'Ср. цикъл на ИИ',
      fromTasks: 'от {n} задачи',
      speedup: 'Ускорение',
      speedupHint: 'приети {h} човекочаса на елемент',
      humanDelivered: 'Доставени човекодни',
      humanDays: 'човекодни',
      forecast: 'Прогноза за отворената работа: {d} човекодни',
      sizes: 'Размери',
      sizeSmall: 'малки',
      sizeMedium: 'средни',
      sizeLarge: 'големи',
      scrumTitle: 'Скръм',
      scrumSubtitle: 'Спринтът, story точките и скоростта, от собствените данни на фирмата',
      sprintLabel: 'Спринт {n}',
      ends: 'приключва',
      committedPts: 'Поети точки',
      deliveredPts: 'Доставени точки',
      remainingPts: 'Оставащи точки',
      burndownTitle: 'Burndown (оставащи точки на ден)',
      velocityTitle: 'Скорост на приключените спринтове',
      predictability: 'предвидимост',
      forecastLine: 'Плъзгаща скорост {v} точки на спринт · беклог {b} точки ≈ {s} спринта',
      noSprint: 'Няма активен спринт; следващото планиране ще открие нов.',
      noItems: 'Още нищо не е поето; спринтът взема това, което хората донесат.',
      colItem: 'Задача',
      colOwner: 'Отговорник',
      colPoints: 'Точки',
      colState: 'Състояние',
      itemDone: 'доставено',
      itemOpen: 'отворено',
      unestimated: 'без оценка',
      addedBy: 'добавено от {who}',
      setGoal: 'Цел на спринта',
      sprintDaysLabel: 'Дължина на спринта (дни)',
      save: 'Запази',
      endSprint: 'Приключи спринта сега',
      confirmEndSprint: 'Да приключа ли спринта сега? Ревюто, ретроспективата и следващото планиране се провеждат веднага.',
      planNow: 'Проведи първото планиране сега',
      confirmPlanNow: 'Да проведа ли планирането на спринта сега? Това открива първия спринт в pAIoneer-scrum.',
      sprintPointsCol: 'Точки в спринта',
      ceremonySpaceLabel: 'Пространство за церемонии',
      scrumOfScrums: 'Проведи Scrum of Scrums сега',
      confirmScrumOfScrums: 'Да проведа ли Scrum of Scrums в pAIoneer-scrum сега?',
      lastScrumOfScrumsTitle: 'Последен Scrum of Scrums',
      escalatedImpedimentsTitle: 'Ескалирани пречки (междуекипни)',
      unitBreakdownTitle: 'Разбивка по звена',
      colUnit: 'Звено',
      colWip: 'Работа в ход',
      colImpediments: 'Пречки',
    },
    nav: {
      groups: {
        gametheory: 'Екипна координация и Scrum',
        demos: 'Прегледи на живо',
        sovereign: 'Суверенен LLM',
        today: 'Дневен преглед и Контролен център',
        organisation: 'Организация',
        work: 'Работа',
        communication: 'Комуникация',
        memory: 'Памет',
        platform: 'Платформа',
        products: 'Продукти',
        identity: 'Идентичност',
      },
      pages: {
        gametheory: 'Екипна координация и Scrum',
        demos: 'Прегледи на живо',
        llm: 'LLM архитектура — статия',
        training: 'Data Lake и Обучение на AI модели',
        today: 'Дневен преглед и Контролен център',
        work: 'Работни пакети и проекти',
        coding: 'Програмни задачи',
        gitlab: 'GitLab и Изграждане на образи',
        agents: 'Агенти и проекти на агенти',
        research: 'Проучвания',
        webex: 'Webex пространства',
        mailboxes: 'Пощенски кутии',
        conversations: 'Обаждания и разговори',
        meetings: 'Срещи',
        engines: 'AI двигатели и GPU',
        usage: 'Потребление и бюджети',
        workloads: 'Контейнерни услуги',
        orchestrator: 'Veridion MCP оркестратор',
      },
      sections: {
        demos: {
          previews: 'Прегледи на живо',
        },
        llm: {
          paper: 'Статия',
          monitoring: 'Наблюдение',
        },
        training: {
          autopilot: "Автопилот",
          storage: "Облачно хранилище и дърво от папки",
          acquisition: "Набавяне на данни и предварителна обработка",
          data: "Данни и граф на знанието",
          training: "Обучение и публикуване",
        },
        platform: {
          nodes: 'Клъстерни възли',
          events: 'Събития',
        },
        smtm: {
          runtime: 'Управление на изпълнението',
          prediction: 'Управление на прогнозите',
          status: 'Състояние на данните',
          reporting: 'Сигнали',
          training: 'Модели',
          console: 'Конзола за обучение',
        },
        agentic: {
          overview: 'Преглед',
          tools: 'Инструменти',
          mcp: 'MCP сървъри',
          activity: 'Активност',
        },
        'company-memory': {
          content: 'Съдържание',
          search: 'Търсене и ситуационни доклади',
          facts: 'Факти',
          entity: 'Обекти',
          remember: 'Записване',
          audit: 'Одитен дневник',
          console: 'Конзола за заявки',
          stores: 'Хранилища',
          graph: 'Граф на знанията',
          day: 'Ден',
            bubbles: 'Области на знания по отдели и Изследвания'
        },
        organisation: {
          chart: 'Организационна схема',
          colleagues: 'ИИ колеги и пощенски кутии',
          voices: 'Гласове',
          people: 'Хора и пространства',
          approvals: 'Одобрения и графици',
          edit: 'Редакция на организацията',
        },
        work: {
          items: 'Работни пакети',
          projects: 'Проекти в разработка',
        },
        gitlab: {
          gitlab: 'GitLab',
          builds: 'Изграждане на образи',
        },
        agents: {
          agents: 'Агенти',
          designs: 'Проекти на агенти',
          definitions: 'Дефиниции',
        },
        usage: {
          identities: 'По идентичност',
          budgets: 'Бюджети за токени',
          company: 'Фирмена инстанция',
          smtm: 'Veridion SMTM',
        },
        orchestrator: {
          runtime: 'Среда за изпълнение',
          mcp: 'MCP сървъри',
          tools: 'Инструменти',
          activity: 'Активност',
        },
      },
      attentionTitle: 'Нужни действия',
      attentionSubtitle: 'Състояния от всички области, които изискват намеса. Едно щракване отваря раздела.',
      attentionNone: 'Няма нужни действия.',
      stateTitle: 'Работно състояние',
      none: 'няма',
      readyOf: '{ready} от {total} готови',
      connectedOf: '{connected} от {total} свързани',
      registeredOf: '{registered} от {total} регистрирани',
      showMore: 'Покажи още',
      shownOf: '{shown} от {total}',
      expand: 'Разгъване',
      collapse: 'Свиване',
      service: 'Услуга',
      serviceLinks: 'Връзки',
      controlsTitle: 'Управление на Veridion Core',
      confirmRemove: 'Да се премахне ли {what}?',
      companyIdentitiesTitle: 'Идентичности на шлюза на фирмената инстанция',
      companyIdentitiesSubtitle: 'Токените на оркестратора и на Veridion Core в текущия прозорец на шлюза, всяка идентичност със своя бюджет.',
      conversationsTitle: 'Разговори от таблото',
      conversationsSubtitle: 'За всеки ИИ колега писмените разговори от таблото; писането и обаждането отварят диалог над страницата.',
      conversationCount: 'Съобщения',
      conversationLastWritten: 'Последно написано',
      conversationLastAnswered: 'Последно отговорено',
      exchangesTitle: 'Съобщения и отговори',
      exchangesSubtitle: 'Всяко съобщение от таблото с отговора на ИИ колегата, най-новите първо.',
      conversationMessage: 'Съобщение',
      conversationAnswer: 'Отговор',
      today: {
        wordTitle: 'Действаща управленска директива',
        wordNone: 'В момента няма въведена отворена управленска директива.',
        sinceTitle: 'Събития от последното посещение',
        sinceState: 'от {time}',
        workTitle: 'Активни задачи и Отговорности',
        workNone: 'Няма работен пакет в процес на работа.',
        nextMeeting: 'Следваща среща',
        lastMeeting: 'Последна среща',
      },
      work: {
        title: 'Работни пакети',
        subtitle: 'Всеки отворен работен пакет от фирмената памет с отговорник, състояние, приоритет, срок и резултатите от сценариите му; заглавието го отваря в графа.',
        item: 'Работен пакет',
        kind: 'Вид',
        owner: 'Отговорник',
        status: 'Състояние',
        priority: 'Приоритет',
        due: 'Срок',
        scenarios: 'Сценарии',
        updated: 'Обновено',
        none: 'Няма отворен работен пакет.',
        all: 'Всички отговорници',
      },
      meetings: {
        subtitle: 'Срещите на ИИ колегите, както ги записва Veridion Core: времеви прозорец, обобщение и ангажиментите, превърнали се в работа.',
        slot: 'Времеви прозорец',
        kind: 'Вид',
        started: 'Започната',
        ended: 'Приключена',
        summary: 'Обобщение',
        commitments: 'Ангажименти',
        hold: 'Проведи среща сега',
        held: 'Срещата е свикана.',
        notHeld: 'Среща тече или е проведена през последния половин час.',
        holdFailed: 'Срещата не можа да бъде свикана',
        none: 'Още няма записана среща.',
      },
      research: {
        title: 'Проучвания',
        subtitle: 'Проучванията на ИИ колегите от хронологията на фирмата, най-новите първо.',
      },
      attention: {
        toneError: 'Повреда',
        toneWarning: 'Бележка',
        state: {
          platform: '{ready} от {workloads} работни натоварвания готови, {nodes} от {total} възела готови, {restarts} рестарта.',
          gateway: '{state}; {models} модела маршрутизирани, {backends} от {total} обслужващи бекенда готови.',
          engine: '{engine}: {running} изпълнявани, {waiting} чакащи',
          usage: '{tokens} токена при {identities} идентичности в прозореца {window}.',
          smtm: 'Прогнозен портал {gate}, преизграждане {rebuild}; {online} от {models} модела онлайн, {failed} неуспешни.',
          smtmSignals: '{open} отворени сигнала, {resolved} решени, {failed} неуспешни доставки.',
          smtmVeridion: '{connected} от {servers} MCP сървъра свързани.',
          company: 'Оркестратор {status}; {ready} от {workloads} работни натоварвания готови; Veridion Core {core}; {agents} агента работят, {waiting} чакат.',
          companyWebex: '{registered} от {bots} webhook-а на ботове регистрирани.',
          approvals: '{approvals} отворени одобрения; {tasks} задачи за кодиране чакат човек или преглед.',
          sessions: '{users} влезли потребители, {sessions} сесии, {mfa} потвърдени, {total} акаунта.',
          mail: 'SMTP {state}.',
        },
        platformUnreadable: 'Състоянието на платформата не може да се прочете.',
        nodeNotReady: 'Възел {name} не е готов.',
        nodePressure: 'Възел {name} съобщава за недостиг: {pressure}.',
        workloadDown: '{name} ({namespace}): готови {ready} от {desired}.',
        gatewayNotProgrammed: 'AI шлюзът не е програмиран.',
        smtmGateClosed: 'Портата за прогнози е затворена.',
        smtmRebuild: 'Маркирано е повторно изграждане.',
        smtmHint: 'Състояние на данните: {hint}.',
        smtmDeliveryFailed: 'Неуспешни доставки на сигнали: {count}.',
        smtmModelsFailed: 'Модели с грешка: {count}.',
        mcpUnreachable: 'MCP сървърът {server} на {instance} е недостъпен.',
        partUnavailable: 'Veridion pAIoneer Labs GmbH: {part} не отговаря.',
        parts: {
          orchestrator: 'оркестраторът',
          webex: 'мостът към Webex',
          knowledge: 'базата знания',
          core: 'Veridion Core',
          mcp: 'MCP сървърите',
          usage: 'регистърът на потреблението',
          gateway: 'потреблението на шлюза',
        },
        emergencyStop: 'Аварийното спиране на Veridion Core е включено.',
        coreMisconfigured: 'На Veridion Core липсват настройки: {missing}.',
        agentsWaiting: 'Агенти, които чакат отговор: {count}.',
        hostedNotRunning: '{agent} не работи.',
        webhookMissing: 'Webhook на {bot} не е регистриран.',
        readerNotAuthorised: 'Четенето на пространствата на компанията не е разрешено.',
        approvalOpen: 'Открито одобрение ({position}): {question}',
        taskWaiting: 'Задача по кодиране чака човек: {title}',
        taskReview: 'Merge request, готов за преглед: {title}',
      },
    },
    ops: {
      showDetails: 'Подробности',
      hideDetails: 'Затваряне',
      mcpVersion: 'Версия',
      mcpUrl: 'Адрес',
      mcpProtocol: 'Транспорт и протокол',
      mcpLastRefresh: 'Последна заявка',
      mcpError: 'Грешка',
      noTools: 'Няма съобщени инструменти.',
      toolServer: 'Произход',
      toolAccess: 'Достъп',
      toolBuiltIn: 'Veridion',
      accessReadOnly: 'чете',
      accessWrites: 'пише',
      accessDestructive: 'променя данни',
      accessUndeclared: 'не е посочено',
      usageTitle: 'Потребление',
      smtmUsageSubtitle: 'Извиквания на модели, токени и разходи, отчетени от доставчика, за последните 30 дни.',
      usageByPerson: 'По човек',
      usageByModel: 'По модел',
      usageByDay: 'По ден',
      model: 'Модел',
      day: 'Ден',
      promptTokens: 'Входни токени',
      completionTokens: 'Изходни токени',
      noUsage: 'Няма записано потребление.',
      runtimeTitle: 'Изпълнение',
      runtimeSubtitle: 'Как оркестраторът на тази инстанция достига моделите си и свързва инструментите си.',
      executionMode: 'Изпълнение',
      providerProtocol: 'Протокол към модела',
      contextWindow: 'Контекстен прозорец',
      requestTimeout: 'Времеви лимит за заявка',
      diagnostics: 'Диагностика',
      diagnosticsOn: 'включена',
      diagnosticsOff: 'изключена (режим на производителност)',
      externalServers: 'Свързани MCP сървъри',
      mcpEndpoint: 'MCP крайна точка',
      workloadsTitle: 'Работни натоварвания',
      workloadsSubtitle: 'Работните натоварвания в пространството от имена paioneer-veridion според Kubernetes.',
      botsTitle: 'Ботове',
      botsSubtitle: 'Ботовете на организацията, всеки със своя webhook, и услугите на моста.',
      botAddress: 'Адрес',
      cardWebhook: 'Webhook за карти',
      webhookState: 'Състояние',
      noBots: 'Мостът не съобщава ботове.',
      bridgeServices: {
        knowledgeBase: 'База знания',
        webResearch: 'Търсене в интернет',
        osint: 'OSINT',
        anonymizer: 'Анонимизация',
      },
      connected: 'свързано',
      notConnected: 'несвързано',
      activeRooms: 'Активни стаи',
      allowedRooms: 'Разрешени стаи',
      surface: 'Повърхност',
      missingSettings: 'Липсващи настройки',
      none: 'няма',
      instanceToolsTitle: 'Инструменти на оркестратора',
      instanceToolsSubtitle: 'Инструментите, които оркестраторът на фирмената инстанция е регистрирал.',
      openMailbox: 'Кутия',
      positionMailboxHint: 'ИИ колегите обработват предавания от други ИИ колеги; задача за ИИ колега се дава в неговото пространство в Webex.',
      mailboxesTitle: 'Пощенски кутии',
      mailboxesSubtitle: 'За всеки агент: какво чака в кутията му, какво е доставено и какво е прочетено. Щракване върху ред филтрира съобщенията.',
      readAt: 'Прочетено в',
      refresh: 'Обновяване',
      mailbox: 'Кутия',
      mailboxKind: 'Вид',
      mailboxKinds: {
        position: 'ИИ колега',
        hosted: 'Хостван агент',
        graph: 'Агент',
      },
      lastMessage: 'Последно съобщение',
      noMailboxes: 'Нито една кутия не може да се прочете.',
      messagesTitle: 'Съобщения',
      messagesSubtitle: 'Съобщения, команди и предавания, най-новите първи. Щракване показва целия текст.',
      allMailboxes: 'Всички кутии',
      allStates: 'Всички състояния',
      time: 'Време',
      from: 'От',
      to: 'До',
      messageKind: 'Вид',
      content: 'Съдържание',
      reply: 'Отговор',
      noMessages: 'Няма съобщения.',
      messageKinds: {
        message: 'Съобщение',
        handover: 'Предаване',
        command: 'Команда',
        resume: 'Продължаване',
        subagent_result: 'Резултат от подагент',
        review: 'Преглед',
      },
      buildsTitle: 'Компилации',
      buildsSubtitle: 'Образите, които Veridion Core е изградил за агенти, най-новите първи.',
      image: 'Образ',
      started: 'Започнато',
      finished: 'Завършено',
      noBuilds: 'Няма компилации.',
      coreToolsTitle: 'Инструменти на агентите',
      coreToolsSubtitle: 'Инструментите на оркестратора, които Veridion Core предлага на агентите си.',
      description: 'Описание',
      coreDailyTitle: 'Потребление по ден и модел',
      coreDailySubtitle: 'Извиквания на модели от Veridion Core за последните 30 дни, по агент и модел.',
      coreActivityTitle: 'Активност на Veridion Core',
      coreActivitySubtitle: 'Събития на агентите, ИИ колегите и предаванията в Veridion Core, най-новите първи.',
      event: 'Събитие',
      tool: 'Инструмент',
      detail: 'Подробност',
    },
    tabCompanyMemory: 'Фирмена памет',
    llmPaper: {
      subtitle: 'Генерираното научно описание на суверенната архитектура на модела — изобразено от paper-документа, който Veridion Core поддържа за активната спецификация.',
      summaryTitle: 'Какво показва тази страница',
      summaryBody: 'Veridion Core поддържа за активната архитектура на модела генериран научен документ: заглавие, резюме, номерирани раздели, диаграма на архитектурата, таблици и литература идват от backend без промяна; проектните стойности са обозначени като такива и страницата не измисля нищо.',
      refresh: 'Обнови',
      exportPdf: 'Експортиране като PDF',
      strandTraining: 'обучава се',
      strandSelected: 'избран',
      lcTitle: "Имплементация и жизнен цикъл",
      lcSelectedTrains: "тренира следващ",
      lcCollectsOnly: "събира и подготвя — не стартира",
      lcSpec: "Спецификация",
      lcFrozen: "замразена",
      lcArtifacts: "Артефакти (токенизатор/кодек)",
      lcReleased: "издадени",
      lcNotReleased: "още не са изградени",
      lcCodecOpen: "кодекът предстои",
      lcData: "Прагове за данни",
      lcThresholdsMet: "изпълнени",
      lcAreasReached: "план за данни: достигнати {met} от {total} области",
      lcNoLake: "езерото от данни е недостъпно",
      lcStage_trainer_image: "Образ на тренера",
      lcStage_sealed_tdv: "TDV запечатана",
      lcStage_compat_all_green: "Съвместимост ALL-GREEN",
      lcStage_vram_budget: "VRAM бюджет",
      lcTraining: "Обучение",
      lcAuto: "стартира автоматично при изпълнени прагове",
      lcBench: "Бенчмарк",
      lcBenchRows: "измервания",
      lcNoneYet: "още няма",
      lcRelease: "Експорт · Hugging Face (частно) · регистър",
      lcReleaseRows: "артефакта",
      lcReleaseNote: "след обучението: частно-проверено качване + запис в регистъра",
      lcPipeline: "Тренировъчен конвейер",
      lcDone: "готово",
      lcActive: "активно",
      lcWaiting: "изчаква",
      lcBlocked: "блокирано",
      lcCapability: "Способност",
      lcSamples: "Примери",
      lcByLanguage: "по език",
      lcForeign: 'друго направление',
      lcCorpus: 'Токени на корпуса',
      lcCorpusNone: 'още не е токенизиран',
      loading: 'Зареждане …',
      unavailable: 'Документът не е достъпен.',
      noPaper: 'Тази версия на Veridion Core още не предоставя paper-документ. Затова страницата не показва нищо измислено.',
      abstract: 'Резюме',
      references: 'Литература',
      appendix: 'Приложение',
      figure: 'Фигура',
      lastUpdated: 'Последно обновяване',
      empty: 'Няма записи.',
    },
    llmMonitor: {
      summary: "Оперативно наблюдение на модела: състояние, данни, GPU, ядра и пропускателна способност, оценки и събития — измерено от Veridion Core и data lake, нищо измислено.",
      archTitle: 'Статус на архитектурата',
      archSubtitle: "Активната архитектура със състоянието на интерфейса за данни и замразяването.",
      version: 'Версия',
      codename: 'Кодово име',
      statusLabel: 'Статус',
      interfaceStatus: 'Интерфейс за данни',
      specSha: 'Хеш на спецификацията (SHA-256, съкратен)',
      promotedAt: 'Повишена',
      frozenLabel: 'Замразена',
      frozenYes: 'Да',
      frozenNo: 'Не',
      stateWord_active: "активна",
      stateWord_draft: "чернова",
      stateWord_released: "освободена",
      stateWord_candidate: "кандидат",
      stateWord_retired: "прекратена",
      gpuModel: "Графична карта",
      gpuTotal: "Обща графична памет",
      gpuWindow: "Прозорец за обучение (измерен)",
      gpuMeasuredAt: "Измерено на",
      gpuSource: "Източник на измерването",
      gpuServing: "Обслужване",
      gpuInferenceTarget: "Цел за инференция на една карта",
      vramTitle: 'GPU и бюджет VRAM',
      vramSubtitle: 'Измереният VRAM бюджет на видеокартата, както го води Veridion Core.',
      vramNone: 'В записа няма VRAM бюджет.',
      gateTitle: 'Гейт за повишаване',
      gateSubtitle: 'Политиката, по която архитектура-кандидат заменя активната, с изискваните метрики и техните тегла.',
      metric: 'Метрика',
      weight: 'Тегло',
      gateNone: 'Няма записани изисквани метрики.',
      candidatesTitle: 'Кандидати',
      candidatesNone: 'Няма архитектури-кандидати.',
      evidenceTitle: 'Оценки',
      evidenceNone: 'Още няма измерени оценки.',
      benchmark: 'Бенчмарк',
      suite: 'Набор',
      score: 'Резултат',
      evaluator: 'Оценител',
      date: 'Дата',
      changelogTitle: 'История на промените',
      changelogNone: 'В историята още няма версии на архитектурата.',
      summaryLabel: 'Резюме',
      createdAt: 'Създадена',
      supersededAt: 'Заменена',
      eventsTitle: 'Събития',
      eventsNone: 'Няма записани събития.',
      implTitle: 'Състояние на реализацията на клона',
      implSubtitle: "Измерени факти: артефакти на интерфейса за данни, избор, токен корпус и векторен индекс; планът за данни по области е в обстановката.",
      implSelected: 'Обучаван клон',
      implSelectedYes: 'избран — обучава се следващ',
      implSelectedNo: 'само подготвя (никога не стартира)',
      implTokenizer: 'Артефакт на токенизатора',
      implCodec: 'Артефакт на кодека',
      implNotReleased: 'още не е публикуван',
      implCapability: 'Способност',
      implSamples: 'Примери (измерено/цел)',
      implNoDatalake: 'Напредъкът на примерите в момента не може да се прочете (интерфейсът на езерото от данни е недостъпен).',
      implSwitchHint: 'Изборът на обучавания клон се превключва на страницата за обучение.',
      implSituationLink: "Къде са данните и какво още липсва за обучението: обстановката на страницата за обучение",
      kernelTitle: 'Ускорение на ядрата и пропускателна способност',
      kernelSubtitle: 'Какво измери сондата за ядра на картата: всяко ядро спрямо своя еталон, бекендът на вниманието, пропускателната способност на избраната спецификация — и планът за време, изчислен от измерени токени и измерена пропускателна способност.',
      kernelNone: 'На тази карта още не е пускана сонда за ядра; нищо не се предполага.',
      kernelName: 'Ядро',
      kernelVerified: 'Доказано',
      kernelYes: 'да',
      kernelNo: 'не',
      kernelSpeedup: 'Ускорение',
      kernelMaxErr: 'Макс. грешка',
      kernelError: 'Констатация',
      kernelAttention: 'Бекенд на вниманието',
      kernelDocMask: 'Маскиране на границите на документите',
      kernelThroughput: 'Измерена пропускателна способност (токени/с)',
      kernelMicroBatch: 'Микропартида',
      kernelMeasuredAt: 'Измерено на',
      kernelImage: 'Образ на тренера (дайджест)',
      kernelRunPath: 'Път на ядрата на последното изпълнение',
      kernelRunNone: 'Все още няма тренировъчно изпълнение с данни за ядрата.',
      kernelPlanTitle: 'План за време (аритметика върху измервания)',
      kernelPlanTokens: 'Маса на токените',
      kernelPlanTokensSource: 'Източник на масата на токените',
      kernelPlanDays: 'Прогнозирани дни за едно преминаване',
      kernelPlanNone: 'Още не е измерено — без измерена пропускателна способност или измерена маса на токените не се измисля план за време.',
      kernelSourceTdv: 'запечатана версия на тренировъчните данни',
      kernelSourceCorpus: 'корпус досега (незапечатан)',
      kernelSourcePlan: "бюджет според статията",
      implForeign: 'принадлежи на друго направление',
      implIndex: 'Векторен индекс (свързване на графа)',
      implIndexNone: 'няма докладван индекс',
      implIndexDown: 'конфигуриран, не отговаря',
      implIndexPoints: 'точки',
      implIndexBackfillDone: 'попълването е завършено',
      implIndexBackfillOpen: 'попълването тече',
      implIndexLink: 'Индекс и дедупликация в монитора на езерото',
      implCorpus: 'Токен корпус (суров текст)',
    },
    software: {
      arch: {
        execTitle: "Суверенна архитектура на модела",
        execSubtitle: "Единствената активна спецификация на архитектурата от Veridion Core: всяко число е или подкрепено от посочен артефакт от измерване, или обозначено от backend-а като проектна цел (неизмерено).",
        openDatalake: "Отвори Data Lake и обучението на AI модела",
        unavailableArch: "Данните за архитектурата са недостъпни.",
        frozen: "Замразена — тече обучително изпълнение",
        notFrozen: "Допусната (фаза A)",
        version: "Версия",
        codename: "Кодово име",
        statusLabel: "Статус",
        createdAt: "Създадена",
        promotedAt: "Повишена",
        specSha: "Хеш на спецификацията (SHA-256)",
        contextWindow: "Контекстен прозорец (проект, токени)",
        dataInterface: "Интерфейс на данните",
        diStatus: {
          draft: "чернова",
          complete: "пълен",
          missing: "липсва",
        },
        paramsTitle: "Баланс на параметрите",
        trainingVramTitle: "VRAM за обучение (декларирано, GB)",
        inferenceTitle: "VRAM за инференция (декларирано, GB)",
        declaredTotal: "Декларирана сума",
        budgetTitle: "Бюджет VRAM на GPU (измерен)",
        budgetGpu: "GPU",
        budgetTotal: "Общ VRAM (MiB)",
        budgetFreed: "Свободен обучителен бюджет (GB)",
        budgetInferenceTarget: "Цел за инференция на една GPU (GB)",
        diagramTitle: "Генерирана диаграма на архитектурата",
        diagramSubtitle: "Генерирана детерминистично от записаната спецификация; редом с данните не съществува ръчно писана диаграма.",
        noDiagram: "Отговорът не съдържа диаграма.",
        stagesTitle: "Стъпаловиден строеж на архитектурата",
        stagesSubtitle: "Директно от записаната спецификация; стойностите на параметрите са проектни.",
        stageCol: "Стъпало",
        layersCol: "Слоеве",
        mechanismCol: "Механизъм",
        paramsCol: "Физически параметри (млрд.) и първоизточници",
        paramsCross: "хоризонтален — отчетен в стъпалата",
        researchTitle: "Изследователски архив за квантов и frontier ИИ",
        researchSubtitle: "Живи редове от изследователския архив на Veridion Core; нови публикации идват чрез инструмента на квантовия колега, всяка с видим произход.",
        researchEmpty: "В архива още няма публикации.",
        evidenceTitle: "Доказателства от оценяване",
        evidenceSubtitle: "Тук се появяват само измерени оценки с препратки; без доказателство няма резултат.",
        evalMetric: "Метрика",
        evalBenchmark: "Бенчмарк",
        evalSuite: "Набор",
        evalScore: "Стойност",
        evalEvaluator: "Оценител",
        evalDate: "Измерено на",
        evalArtifact: "Артефакт на доказателството",
        gateTitle: "Правила за повишение (портал на доказателствата)",
        gateMetrics: "Задължителни метрики",
        gateEpsilon: "Толеранс (епсилон)",
        gateConfigVersion: "Конфигурация на портала (версия)",
        candidatesTitle: "Опашка на кандидатите",
        candidatesSubtitle: "Подадени кандидати за архитектура със състоянието на техните доказателства; подаването минава през изследователската среда, никога през таблото.",
        candidateSubmittedBy: "Подаден от",
        candidateEvidence: "Доказателства (налични / изисквани)",
        candidatesEmpty: "Няма подаден кандидат.",
        changelogTitle: "Дневник на проектните промени",
        changelogSubtitle: "Заменени проектни итерации — съзнателно без числа: за тях никога нищо не е измервано.",
        changelogSummary: "Резюме",
        changelogEmpty: "Няма заменен проект.",
        supersededAt: "Заменена на",
        eventsTitle: "Събития на портала",
        eventsSubtitle: "Подавания, повишения, откази и превключвания на замразяването, както порталът ги е записал.",
        eventsEmpty: "Още няма събития.",
      },
      title: 'Разработка на софтуер',
      subtitle: 'Задачите на агента за програмиране, GitLab на компанията със синхронизацията от Azure DevOps, merge requests, които чакат преглед, и границите на възела GitLab.',
      openGitlab: 'Отвори GitLab',
      openSonar: 'Отвори SonarQube',
      loading: 'Зарежда се …',
      failed: 'Не се получи',
      done: 'Готово',
      unavailable: 'Недостъпно',
      capacityTitle: 'Възел GitLab',
      capacitySubtitle: 'Пазачът задава границите на възела всяка минута според натоварването на сървъра; продукцията запазва резерва си.',
      stateLabel: 'Състояние',
      memory: 'Памет',
      cpu: 'CPU',
      disk: 'Диск',
      hostFree: 'Свободно на сървъра',
      reserve: 'Резерв за продукцията',
      codingSlots: 'Задачи едновременно',
      pipelineQuota: 'Задания на конвейера',
      recentActions: 'Последни намеси на пазача',
      syncTitle: 'Синхронизация от Azure DevOps',
      syncSubtitle: 'Master в GitLab следва master в Azure; комитите, които е имал само GitLab, се пазят под таг replaced/<час>.',
      syncNow: 'Синхронизирай сега',
      syncStarted: 'Синхронизацията е стартирана',
      azureCommit: 'Master в Azure',
      gitlabCommit: 'Master в GitLab',
      lastChange: 'Последна промяна',
      lastRun: 'Последно изпълнение',
      replaced: 'Запазено под тагове',
      noneReplaced: 'нищо',
      jobs: 'Последни изпълнения',
      error: 'Грешка',
      readyTitle: 'Merge requests, готови за преглед',
      readySubtitle: 'Само merge requests със зелен конвейер; сливането става в GitLab.',
      noReady: 'Няма merge request, който да чака преглед.',
      tasksTitle: 'Задачи по програмиране',
      tasksSubtitle: 'Всяка програмистка работа на агента със състояние, merge request и токени.',
      showFinished: 'Покажи приключените задачи',
      task: 'Задача',
      requester: 'Възложител',
      statusLabel: 'Състояние',
      mergeRequest: 'Merge request',
      pipeline: 'Конвейер',
      tokens: 'Токени',
      updated: 'Обновено',
      noTasks: 'Все още няма задачи по програмиране.',
      phase: 'Стъпка',
      repository: 'Хранилище',
      branch: 'Клон',
      openQuestion: 'Отворен въпрос',
      result: 'Резултат',
      sendMessage: 'Пиши на задачата',
      answerQuestion: 'Отговори на въпроса',
      urgent: 'Спешно: насочи текущата стъпка веднага',
      send: 'Изпрати',
      messageSent: 'Доставено до задачата',
      confirmCancel: 'Да се прекрати ли задачата? Отворен merge request ще бъде затворен.',
      course: 'Ход на сесията',
      messages: 'Съобщения',
      events: 'Събития',
      none: 'няма',
      close: 'Затвори',
      newTitle: 'Нова задача',
      newSubtitle: 'Възложете оттук задача на агента за програмиране; следете я тук и на картата ѝ в Webex.',
      brief: 'Какво трябва да направи агентът?',
      issue: 'Задача в YouTrack (по избор)',
      create: 'Създай задача',
      created: 'Задачата е създадена',
      usersTitle: 'Администратори в GitLab',
      usersSubtitle: 'Всеки администратор има потребител в GitLab с администраторски права; housekeeping ги поддържа в съответствие с Keycloak.',
      email: 'Имейл',
      gitlabUser: 'Потребител в GitLab',
      lastHousekeeping: 'Последен housekeeping',
      sonarDeleted: 'Премахнати проекти в SonarQube на изтрити клонове',
      previewsTitle: 'Проекти в разработка',
      previewsSubtitle: 'Всеки проект в разработка работи точно веднъж от първото сливане: Veridion Core стартира най-новото зелено състояние на основния клон (migration или master) в контейнери зад администраторския вход, обновява го при всеки зелен pipeline, а контейнерите се стартират, спират и рестартират тук. Проект, чийто pipeline не изгражда нищо работещо, стои тук с причината.',
      previewsSummaryTitle: 'Какво показва този изглед',
      previewsSummaryBody: 'Всеки проект в разработка работи като собствен контейнер за преглед зад администраторския вход. Списъкът горе показва най-новото работещо състояние на всеки проект, таблицата отдолу — работещите контейнери със състояние, адрес и управление: отваряне, стартиране, спиране, рестартиране.',
      previewProject: 'Проект',
      previewState: 'Работещо състояние',
      previewSince: 'От',
      previewAddress: 'Адрес',
      previewMergedAt: 'Слято',
      noPreviews: 'Нито един проект не работи.',
      reasonsLabel: 'Блокиращи причини и Диагностика',
      noProjects: 'Няма проект в разработка.',
      qualityCoverage: 'Покритие с тестове',
      qualityBugs: 'Бъгове',
      qualitySmells: 'Code smells',
      qualityDuplication: 'Дублиране',
      qualityHotspots: 'Отворени hotspots',
      qualityUnavailable: 'Няма измервания от SonarQube',
      openPreview: 'Отвори',
      startPreview: 'Стартирай контейнерите',
      stopPreview: 'Спри контейнерите',
      previewStarted: 'Контейнерите са стартирани',
      previewStopped: 'Контейнерите са спрени',
      restartPreview: 'Рестартирай контейнерите',
      previewRestarted: 'Контейнерите са рестартирани',
      previewControl: 'Контейнери',
      resultTitle: 'Резултат в GitLab',
      resultJobs: 'Задачи и артефакти',
      resultSonar: 'SonarQube',
      resultDelivered: 'Доставено',
      previewStatus: {
        starting: 'стартира',
        running: 'работи',
        stopped: 'спрян',
        failed: 'неуспешен',
      },
      capacityStates: {
        ok: 'в границите',
        tight: 'тясно: продукцията има нужда от място',
        full: 'пълно: без нова работа',
        node_down: 'възелът не работи',
      },
      status: {
        queued: 'чака свободно място',
        working: 'в работа',
        waiting: 'чака отговор',
        review: 'в преглед',
        merged: 'слято в GitLab',
        done: 'готово',
        needs_person: 'нужен е човек',
        rejected: 'затворено без сливане',
        paused: 'на пауза',
        cancelled: 'прекратено',
        failed: 'неуспешно',
      },
      commands: {
        pause: 'Пауза',
        resume: 'Продължи',
        cancel: 'Прекрати',
      },
      repositoryChoice: {
        auto: 'Агентът решава',
        company: '{project} (слива човек)',
        own: 'Собствен проект в {group}',
      },
      userState: {
        ok: 'в съответствие',
        created: 'създаден',
        unblocked: 'отблокиран',
        'made administrator': 'направен администратор',
        blocked: 'блокиран',
      },
    },
    org: {
      write: 'Пиши',
      call: "Обаждане",
      callTitle: "Разговор с {bot}",
      writeTitle: 'Съобщение до {bot}',
      callConfirmEnd: 'Да се прекрати ли обаждането?',
      callSubtitle: 'Микрофонът работи през целия разговор. Ботът поздравява със своя глас, отговаря кратко, пита при отворени точки и може да бъде прекъсван. Всяко изречение стои и в Webex, в директната стая с бота.',
      callRinging: "Звъни …",
      callConnected: "Свързан",
      callEnded: "Приключен",
      callEndedHangup: "Затворихте",
      callEndedClosed: "Връзката беше прекъсната",
      callEndedSilence: "90 секунди тишина",
      callEndedLimit: "Достигната е границата от 30 минути",
      callEndedError: "Грешка прекрати разговора",
      callHangUp: "Затвори",
      callLevel: "Ниво на микрофона",
      callYou: "Вие",
      callSpeaking: "Ботът говори …",
      callThinking: 'Отговорът се генерира …',
      callOvertaken: "изпреварен от следващия ви въпрос, не е изговорен",
      callNothingHeard: "Не бяха чути думи.",
      callMicDenied: "Браузърът отказа микрофона; разрешете го за тази страница и се обадете отново.",
      callNoVoice: "Гласът в момента не е наличен; отговорът остава като текст.",
      callRefused: "Обаждането не беше прието: билетът беше невалиден или изтекъл; обадете се отново.",
      callFailed: "Обаждането се провали",
      voice: "Глас",
      voiceHint: "Гласът, с който говори този колега: в Webex, когато човек поиска да чуе отговора, и по телефона. По подразбиране това е говорител на аудио модела в OpenRouter; собствен, клониран глас от хранилището на гласове говори чрез гласовия двигател на платформата.",
      voiceSave: "Запази гласа",
      voiceDefault: "по подразбиране",
      voiceNone: "без глас",
      voiceCloud: "Говорители на OpenRouter (по подразбиране)",
      voiceOwn: "Собствени гласове (клонирани)",
      voiceUploadTitle: "Качване на гласова проба за този колега",
      voiceUploadHint: "Аудио или видео, най-много 25 MB; Core преобразува пробата, запазва до 20 секунди, чува думите ѝ и съхранява само референтния клип. Колегата веднага говори с този глас.",
      voiceUploadName: "Име на гласа",
      voiceUploadConsent: "Потвърждавам, че имам право да използвам този глас за фирмата: той е мой или лицето е дало съгласие.",
      voiceUploadButton: "Качи пробата",
      voiceUploadDone: "Гласът е запазен",
      voiceTooLarge: "Файлът е по-голям от 25 MB.",
      voicesTitle: "Гласове",
      voicesSubtitle: "Всеки глас на фирмата е референтен клип в хранилището за гласове на Veridion Core; гласовият двигател го клонира при всяко говорене. Деветте предишни говорители стоят в него като записани клипове.",
      voiceSeconds: "Секунди",
      voiceSource: "Произход",
      voiceSourcePreset: "записан говорител",
      voiceSourceUpload: "качена проба",
      voiceAddedBy: "Добавен от",
      voiceConsentBy: "Съгласие потвърдено от",
      voiceWords: "Думи на клипа",
      voiceDelete: "Изтрий",
      voiceConfirmDelete: "Да се изтрие ли този глас? Колегите, които го ползват, ще говорят отново със стандартния си глас.",
      voiceCapture: "Запис на говорителите на preset двигателя",
      voiceCaptureHint: "Изговаря по едно фиксирано изречение на говорител през preset двигателя и го запазва като клип; изпълнява се преди смяната на двигателя.",
      voiceCaptured: "Записани",
      voiceEnginePresets: "Гласовият двигател предлага фиксирани говорители; хранилището за гласове не се използва.",
      chartTitle: "Организационна схема",
      executiveTitle: 'Ръководно ниво',
      unitsTitle: 'Бизнес звена',
      unitLead: 'Ръководител',
      unitSupporting: 'С подкрепата на',
      unitMission: 'Мисия',
      unitPrefix: 'Префикс на нишката',
      standingActive: 'активен',
      standingStandby: 'в готовност',
      standbyOn: 'Постави в готовност',
      standbyOff: 'Активирай',
      standbyHint: 'В готовност колегата не поема ход по инициатива на фирмата и не струва токени; директно съобщение от човек все още получава отговор.',
      confirmStandby: 'Да поставя ли {name} в готовност?',
      confirmActivate: 'Да активирам ли {name}?',
      activity: 'Дейност',
      runtime: 'Среда за изпълнение',
      modelCloud: 'облачен модел',
      modelGpu: 'фирмен двигател',
      callModel: 'Телефонен модел',
      calls30: 'Обаждания, последни 30 дни',
      telemetryLine: '{model} · {prompt}+{completion} токена · {cost} · ухо {asr} ms · ум {llm} ms · глас {tts} ms · общо {total} ms{deferred}',
      telemetryDeferred: ' · {count} отложени',
      chartSubtitle: "AI колегите на Veridion: агенти във Veridion Core, всеки достъпен като собствен бот в Webex, по области; над тях хората, които вземат решения, под тях агентите без собствен бот и фирмените пространства, прочетени на живо от Veridion Core и Webex.",
      chartPeople: "Хора, които вземат решения",
      chartPeopleText: "Хората, които вземат решения, решават всичко и действат в {space}.",
      chartAgentsTitle: "Агенти без собствен бот: coding агентът, Veridion MCP оркестраторът и агентите, които архитектът изгражда, работят от името на AI колега и говорят чрез неговия бот",
      chartDesigned: "Агенти, проектирани с архитекта",
      chartFor: "От името на",
      chartSystemsTitle: "Свързани системи",
      chartSpaceHome: "Основно пространство на",
      chartSpacePurpose: "Предназначение",
      chartRoomsTitle: "Фирмени пространства в Webex",
      room: "Пространство",
      roomBots: "Ботове",
      positionsTitle: "ИИ колеги",
      positionsSubtitle: "Всеки ИИ колега отговаря чрез собствения си бот и чете своите пространства. Описанието му е инструкцията, по която работи.",
      bot: "Бот",
      position: "Функция",
      statusLabel: "Състояние",
      tokensUsed: "Използвани токени",
      tokens30: "Токени, последните 30 дни",
      edit: "Редактиране",
      close: "Затваряне",
      description: "Описание на ИИ колегата",
      save: "Запазване",
      resetDescription: "Възстановяване на стандартното описание",
      interests: "Профил на интересите",
      interestsHint: "Кои видове точки и теми засягат този ИИ колега и кога той не е засегнат. ИИ колегата преценява всяко съобщение в своите пространства спрямо него.",
      threshold: 'Праг за изказвания без запитване',
      thresholdHint: 'От 1 до 5: колко силно съобщението трябва да засяга ИИ колегата, преди той да се изкаже, без да е питан. При 1 се изказва и при слаба засегнатост, при 5 само при силна.',
      saveProfile: "Запазване на профила",
      tools: "Инструменти",
      decisionMakersTitle: "Хора, които вземат решения",
      decisionMakersSubtitle: "Всеки от тях може да дава всяко одобрение и да отговаря на всеки въпрос на ИИ колега в Webex.",
      email: "Имейл адрес",
      add: "Добавяне",
      remove: "Премахване",
      confirmRemove: "Да се премахне ли този човек?",
      readerTitle: "Четене на фирмените пространства",
      readerSubtitle: "Ботът вижда само съобщенията, в които е споменат. Veridion чете всяко съобщение във фирмените пространства чрез разрешението на акаунт, който е член на всички тях.",
      notConfigured: "Интеграцията не е настроена",
      authorised: "Разрешено",
      notAuthorised: "Не е разрешено",
      account: "Акаунт",
      validUntil: "Токенът за достъп е валиден до",
      renewUntil: "Разрешението може да се подновява до",
      authorise: "Разрешаване на четенето",
      authoriseAgain: "Повторно разрешаване",
      linkOpened: "Входът в Webex се отвори в нов раздел.",
      found: "намерено",
      notFound: "не е намерено",
      botsInSpace: "ботове",
      transcripts: "Протоколи от срещи",
      yes: "да",
      no: "не",
      approvalsTitle: "Отворени одобрения",
      approvalsSubtitle: "Одобрения и въпроси, поискани от ИИ колегите, на които още никой не е отговорил.",
      originSpace: "Пространство",
      directRoom: "директен разговор",
      approvalKinds: { review: "одобрение", question: "въпрос" },
      schedulesTitle: "Графици",
      schedulesSubtitle: "Повтаряща се работа, поискана в пространство; изпълнява се, докато някой не я спре.",
      createdBy: "поискано от",
      lastRun: "последно изпълнение",
      end: "Спиране",
      confirmEnd: "Да се спре ли този график?",
      none: "Няма",
      loading: "Зареждане…",
      failed: "Неуспешно",
      working: "В процес…",
      done: "Готово",
      memoryTitle: "Организация",
      memorySubtitle: "Хората и ИИ колегите във фирмата с обхвата на паметта, в който работи всеки ИИ колега.",
      memoryMember: "Член",
      area: "Звено",
      decisionMaker: "Взема решения",
      status: { running: "работи" },
    },
    core: {
      conversationTitle: 'Разговор от таблото',
      conversationHint: 'Всяко съобщение и всеки отговор се казват и в Webex: в нишката на работата на агента, иначе във вашата директна стая с бота.',
      conversationEmpty: 'Още няма съобщение от таблото.',
      writeToAgent: 'Съобщение до този агент',
      answerPending: 'Отговорът предстои',
      title: 'Veridion Core',
      subtitle: 'Агентната операционна система зад фирмения бот: неговите агенти, техните съобщения и разход на токени, дефинициите, архитектът и организацията.',
      done: 'Готово.',
      failed: 'Не се получи',
      loading: 'Зареждане …',
      working: 'Обработка …',
      none: 'Няма.',
      unavailable: 'Veridion Core не е достъпен',
      errors: {
        AGENT_FINISHED: 'Агентът е приключил и не приема повече съобщения',
        EMERGENCY_STOP: 'Аварийното спиране е включено',
        DEFINITION_INVALID: 'Дефиницията не е валидна',
        TOO_MANY_AGENTS: 'Работят твърде много агенти',
        VERIDION_CORE_NOT_CONFIGURED: 'Veridion Core не е конфигуриран',
        MESSAGE_EMPTY: 'Съобщението е празно',
      },
      status: {
        building: 'изгражда се образ',
        starting: 'стартира',
        running: 'работи',
        waiting: 'чака',
        idle: 'в готовност',
        paused: 'на пауза',
        completed: 'завършен',
        failed: 'неуспешен',
        cancelled: 'отменен',
        stopped: 'спрян',
        not_deployed: 'не е внедрен',
      },
      statusLabel: 'Статус',
      owner: 'Собственик',
      definition: 'Дефиниция',
      parent: 'Родителски агент',
      tokens: 'Токени',
      progress: 'Напредък',
      close: 'Затвори',
      openQuestion: 'Отворен въпрос',
      result: 'Резултат',
      answerQuestion: 'Отговорете на въпроса',
      sendMessage: 'Съобщение до агента',
      urgent: 'Спешно: прекъсване на текущата стъпка',
      send: 'Изпрати',
      messageSent: 'Доставено до агента.',
      commands: {
        pause: 'Пауза',
        resume: 'Продължи',
        cancel: 'Отмени',
        kill: 'Прекрати незабавно',
      },
      confirmKill: 'Незабавно прекратяване на този агент и неговите подагенти?',
      subAgents: 'Подагенти',
      graph: 'Граф',
      messages: 'Съобщения',
      messageStatus: {
        queued: 'в опашка',
        delivered: 'доставено',
        consumed: 'прочетено',
        refused: 'отказано',
      },
      events: 'Събития',
      containerLog: 'Лог на контейнера',
      version: 'Версия',
      activeAgents: 'Работещи агенти',
      updated: 'Обновено',
      archived: 'архивирана',
      noDefinitions: 'Все още няма дефиниции.',
      versions: 'Версии',
      from: 'от',
      startInput: 'Начални входни данни като JSON',
      agentStarted: 'Агентът е стартиран.',
      startAgent: 'Стартирай агент',
      editAsJson: 'Редактирай като JSON',
      confirmArchive: 'Архивиране на тази дефиниция? Работещите агенти продължават да работят.',
      archive: 'Архивирай',
      definitionJson: 'Дефиниция като JSON',
      definitionJsonHint: 'Дефиниция на графовия език на Veridion. Валидирането показва нейните проблеми и нейния граф; при запазване тя се съхранява като нова одобрена версия.',
      checked: 'Проверено.',
      validate: 'Валидирай',
      saved: 'Запазено като нова версия.',
      saveVersion: 'Запази като нова версия',
      valid: 'Дефиницията е валидна.',
      you: 'Вие',
      architect: 'Архитект',
      architectPlaceholder: 'Опишете какво трябва да прави агентът …',
      newDesign: 'Нов проект',
      unitKinds: {
        company: 'фирма',
        department: 'отдел',
        team: 'екип',
        project: 'проект',
      },
      partOf: 'част от',
      confirmRemove: 'Премахване на тази единица? Членовете ѝ губят този обхват.',
      remove: 'премахни',
      addUnit: 'Добавяне на единица',
      unitId: 'Идентификатор (малки букви, тирета)',
      unitName: 'Име',
      add: 'Добави',
      addMember: 'Добавяне на член',
      memberKinds: {
        person: 'лице (имейл адрес)',
        agent: 'агент (идентификатор)',
        definition: 'дефиниция (идентификатор)',
      },
      memberId: 'Имейл адрес или идентификатор',
      role: 'Роля',
      confirmEmergencyOn: 'Спиране на всички агенти сега? Ботът продължава да отговаря.',
      confirmEmergencyOff: 'Освобождаване на аварийното спиране?',
      emergencyStop: 'Аварийно спиране',
      emergencyRelease: 'Освободи аварийното спиране',
      emergencyActive: 'аварийното спиране е включено',
      autopilotOn: 'Включване на автопилота',
      autopilotOff: 'Изключване на автопилота',
      autopilotActive: 'Автопилотът е активен: Veridion Core сам отговаря на всяка карта към хората',
      autopilotUnitsTitle: 'Автопилот по бизнес единица',
      autopilotUnitsHint: 'Включва или изключва автопилота поотделно за всяка бизнес единица и за изпълнителния слой. Задържаната работа остава недокосната.',
      autopilotUnitOn: 'Автопилот вкл.',
      autopilotUnitOff: 'Автопилот изкл.',
      limitsBuilds: 'Билдове на образи на колега и ден',
      limitsDesigns: 'Проекти на агенти на колега и ден',
      limitsSave: 'Задай дневни лимити',
      limitsNone: '0 = без лимит',
      confirmAutopilotOn: 'Да се включи ли автопилотът? Собственият решаващ на Veridion Core веднага ще отговаря на всяка отворена и всяка нова карта в pAIoneer-humans-and-bots, видимо в нишката на картата.',
      confirmAutopilotOff: 'Да се изключи ли автопилотът? Оттогава отново решават хората.',
      model: 'Модел',
      codingModel: 'Модел за програмиране',
      modelsTitle: 'Модели по роля',
      modelsSubtitle: 'На кой модел мисли всяка роля на Veridion Core: лицето и управлението на фирмата, телефонът, архитектът и съдията на преценките по изискванията. Могат да се избират само модели, които шлюзът маршрутизира; празно означава стандарта на конфигурацията.',
      roleCoordinator: 'Координатор (лице и управление)',
      roleCall: 'Телефон',
      roleArchitect: 'Архитект',
      roleRequirementsJudge: 'Съдия по изискванията',
      roleJudge: 'Преценки на Core',
      roleEar: 'Телефонно ухо',
      roleStt: 'Webex ухо',
      modelGroupVllm: 'vLLM (собствена карта)',
      modelGroupAudio: 'Аудио (собствена карта / облак)',
      modelGroupCloud: 'OpenRouter (облак)',
      directLlmTitle: 'Директен достъп до LLM',
      directLlmSubtitle: 'Говорете директно с vLLM или облачен модел, без ботове, агенти или Webex',
      directLlmHint: 'Директен администраторски достъп: избраният модел отговаря суров, записан под „console“, без lanes, роли или инструменти.',
      directLlmModel: 'Модел',
      directLlmSystem: 'Системен промпт (по избор)',
      directLlmSystemPlaceholder: 'напр. Ти си …',
      directLlmPrompt: 'Съобщение',
      directLlmPromptPlaceholder: 'Какво искате да попитате модела директно?',
      directLlmSend: 'Изпрати',
      directLlmSending: 'Изпраща …',
      directLlmUsage: '{prompt}+{completion} токена · {cost}',
      modelCurrent: 'В употреба',
      modelDefault: 'Стандарт',
      modelChosen: 'Избран',
      modelDefaultOption: 'стандартът на конфигурацията',
      modelNotRouted: 'не се маршрутизира от шлюза',
      modelSave: 'Запази',
      engineSilver: 'Фирмен двигател (сребро)',
      engineGold: 'Фирмен двигател (злато, на оркестратора)',
      callsTitle: 'Телефонни обаждания',
      callsSubtitle: 'Всеки изговорен ход на телефона, осчетоводен отделно от работата на колегите: токени, разходи и времето на ухото, ума и гласа, по колега и модел, за последните 30 дни и днес; отдолу най-новите ходове.',
      callsTurns: 'Ходове',
      callsCalls: 'Обаждания',
      callsAvgTotal: 'Ø общо ms',
      callsAvgAsr: 'Ø ухо ms',
      callsAvgLlm: 'Ø ум ms',
      callsAvgTts: 'Ø глас ms',
      callsDeferred: 'Отложени',
      callsToday: 'Днес',
      callsWindow: 'Последни 30 дни',
      callsRecent: 'Най-нови ходове',
      callsPerson: 'Човек',
      callsRounds: 'Рундове',
      callsNone: 'Още няма осчетоводено обаждане.',
      unitKindExecutive: 'Ръководно ниво',
      unitKindBusinessUnit: 'Бизнес звено',
      orgSynced: 'Ръководното ниво и бизнес звената са дефинирани в организацията на Veridion Core и синхронизирани тук; променят се там, не на тази страница.',
      memory: 'Памет',
      ready: 'готова',
      notReady: 'не е готова',
      factExtraction: 'извличането на факти е включено',
      cluster: 'Достъп до клъстера',
      agentsRunning: 'Работещи агенти',
      agentsWaiting: 'чакащи',
      definitions: 'Дефиниции',
      gatewayIdentity: 'Идентичност в gateway',
      gatewayTokens: 'Токени в gateway за времевия прозорец',
      hostedTitle: 'Хоствани агенти',
      hostedSubtitle: 'AI приложения, които Veridion Core стартира и поддържа в собствени контейнери.',
      agent: 'Агент',
      actions: 'Действия',
      confirmHosted: '{action}: {agent}?',
      hostedActions: {
        start: 'стартиране',
        stop: 'спиране',
        restart: 'рестартиране',
      },
      open: 'отвори',
      agentsTitle: 'Агенти',
      agentsSubtitle: 'Всеки агент и подагент работи в собствен контейнер. Отворете агент, за да му изпратите съобщение или да го управлявате.',
      showFinished: 'Покажи приключилите агенти',
      noAgents: 'Няма агенти.',
      definitionsTitle: 'Дефиниции',
      definitionsSubtitle: 'Одобрени графи на агенти с техните версии.',
      designsTitle: 'Проекти на агенти',
      designsSubtitle: 'Всеки агент, проектиран от архитекта, за човек или за работата на ИИ колега: за какво и защо, всеки въпрос с отговора, тестовите изпълнения спрямо сценариите, одобрението и изпълненията.',
      design: 'Проект',
      designFor: 'За',
      designWork: 'Работа',
      designState: 'Състояние',
      designApprovedBy: 'Одобрен от',
      designAgent: 'Създаден агент',
      filterState: 'Състояние',
      filterAll: 'Всички',
      filterOpen: 'Отворени',
      filterDone: 'Готови',
      filterFailed: 'Неуспешни',
      filterCurrent: 'Активни и наскоро неуспешни',
      filterActive: 'Активни',
      filterFinished: 'Приключени',
      filterPosition: 'ИИ колега',
      pagePrev: 'Назад',
      pageNext: 'Напред',
      pageLabel: 'Страница',
      searchLabel: 'Търсене',
      showMore: 'Покажи още',
      noDesigns: 'Все още няма проектиран агент.',
      designReason: 'Защо инструментите не стигаха',
      designRecord: 'Протокол',
      designAgents: 'Агенти на проекта',
      designTestRun: 'Тестово изпълнение',
      designRun: 'Изпълнение',
      designStatus: { designing: 'проектира се', testing: 'в тест', asking: 'чака отговор', approval: 'чака одобрение', running: 'работи', done: 'готово', failed: 'неуспешно', cancelled: 'отменено' },
      builtBy: 'Създаден от',
      builtFor: 'За работата',
      viaCodingTask: 'чрез агента за програмиране',
      designTests: 'Тестови изпълнения',
      designRuns: 'Изпълнения',
      designByPerson: 'човек в разговор',
      diagramsTitle: 'Диаграми',
      diagramsSubtitle: 'Изображения на процеси, архитектури и планове, начертани от ИИ колеги, агенти и агента за програмиране, със заглавие, легенда и Mermaid код.',
      noDiagrams: 'Все още няма диаграма.',
      diagramAuthor: 'Автор',
      diagramBasedOn: 'Разширява',
      diagramCode: 'Mermaid код',
      architectTitle: 'Архитект',
      architectSubtitle: 'Проектиране на агент в разговор. Архитектът пита за това, което не може да реши сам, и създава агента едва след Вашето одобрение.',
      orgTitle: 'Организация',
      orgSubtitle: 'Отдели, екипи и проекти с техните членове; фирмената памет се споделя според тази структура.',
      usageTitle: 'Потребление по агент',
      usageSubtitle: 'Извиквания на модели, токени и отчетени разходи за последните 30 дни.',
      calls: 'Извиквания',
      source: 'Източник',
      gpuTokens: 'Токени на видеокартата',
      cloudTokens: 'Токени в облака',
      usageByModel: 'По колега и модел',
      cost: 'Разходи',
    },
    memory: {
      archOverviewTitle: "Преглед на архитектурата: как е изградена паметта на компанията",
      archOverviewText: "Veridion Core съхранява знанието на компанията в три слоя: Neo4j като времеви граф на знанието за факти, решения и работни пакети, PostgreSQL за транзакционните състояния на агенти, пощенски кутии и спринтове и Qdrant за векторно търсене в документите на компанията. Всяко бизнес звено работи в предметно изолиран домейн на знанието; резултатите между звената минават през протоколирани предавания.",
      clustersTitle: "Домейни на знанието на бизнес звената",
      clustersSubtitle: "Всяко бизнес звено работи в обособен домейн на знанието в Neo4j; броят на възлите и ребрата идва на живо от Neo4j, описанията — от обозначеното първоначално зареждане. Клик отваря домейна в графа на знанието.",
      clusterCode: "Код",
      clusterName: "Домейн на знанието",
      clusterId: "Идентификатор",
      clusterRoles: "Роли",
      clusterBridges: "Мостове за предаване",
      clusterPolicy: "Предметен фокус и правило за изолация",
      clusterCounts: "Възли / ребра (на живо)",
      clusterInsights: "Констатации (първоначално зареждане)",
      clusterOpenButton: "Отвори в графа на знанието",
      countsUnavailable: "Neo4j е недостъпен — без преброяване",
      researchTitle: "Изследователски архив за квантов и frontier ИИ",
      researchSubtitle: "Ключови научни публикации и архитектурни референции — живи редове от Veridion Core; произходът на всеки ред е видим.",
      researchEmpty: "В архива още няма публикации.",
      researchIngestNote: "Нови публикации добавя квантовият колега чрез своя инструмент; таблото само чете архива.",
      researchPublication: "Публикация",
      researchMechanism: "Ключов механизъм",
      researchRelevance: "Значимост за архитектурата",
      researchOrigin: "Произход",
      researchSeeded: "първоначално зареждане",
      researchMotivates: "Обосновава версия",
      title: 'Фирмена памет',
      subtitle: 'Какво съхранява Veridion Core в Neo4j: спомени по обхват, факти с периода им на валидност и одит на действията на агентите.',
      failed: 'Не се получи',
      loading: 'Зареждане …',
      unavailable: 'Паметта не е достъпна',
      database: 'База данни',
      ready: 'готова',
      notReady: 'не е готова',
      factExtraction: 'Извличане на факти',
      episodesQueued: 'Чакащи епизоди',
      lastError: 'Последна грешка',
      contentTitle: 'Съдържание',
      contentSubtitle: 'Възли по етикет и спомени по обхват и вид.',
      label: 'Етикет',
      count: 'Брой',
      empty: 'Все още няма нищо.',
      scope: 'Обхват',
      kind: 'Вид',
      kinds: {
        fact: 'факт',
        decision: 'решение',
        task: 'задача',
        procedure: 'процедура',
        note: 'бележка',
        episode: 'епизод',
      },
      searchTitle: 'Търсене',
      searchSubtitle: 'Извличането, което агентите използват: смисъл, думи и извлечени факти.',
      searchPlaceholder: 'Термин за търсене или въпрос',
      allScopes: 'всички обхвати',
      search: 'Търси',
      noResults: 'Нищо не е намерено.',
      text: 'Текст',
      validFrom: 'Валиден от',
      source: 'Източник',
      extracted: 'извлечен',
      recorded: 'записан',
      rememberTitle: 'Запомняне',
      rememberSubtitle: 'Съхранете факт, решение, задача, процедура или бележка в даден обхват.',
      remembered: 'Запазено.',
      remember: 'Запомни',
      created: 'Създадено',
      validity: 'Валидност',
      invalid: 'невалиден',
      confirmInvalidate: 'Да се отбележи ли този спомен като вече невалиден?',
      invalidate: 'отбележи като невалиден',
      forget: 'забрави',
      confirmForget: 'Да се забрави ли този запис окончателно? Той се изтрива от паметта и не може да бъде възстановен.',
      forgotten: 'Забравено.',
      factsTitle: 'Факти във времето',
      factsSubtitle: 'Факти, извлечени от разговори и резултати на агенти; опроверганият факт получава крайна дата.',
      noFacts: 'Все още няма извлечени факти.',
      briefsTitle: 'Обобщения на ИИ колегите',
      briefsSubtitle: 'Какво чете първо всеки ИИ колега: отворени ангажименти, валидни решения, текущи задачи и клиенти, написано всяка нощ от паметта.',
      brief: 'Обобщение',
      updated: 'Обновено',
      noBriefs: 'Все още няма написани обобщения.',
      fact: 'Факт',
      from: 'От',
      to: 'До',
      validUntil: 'Валиден до',
      stillValid: 'все още валиден',
      entityTitle: 'Обкръжение',
      entitySubtitle: 'С какво е свързана задача, проект, лице, система или същност.',
      entityPlaceholder: 'Име, идентификатор на задача, имейл адрес или идентификатор',
      show: 'Покажи',
      auditTitle: 'Одит',
      auditSubtitle: 'Извиквания на модели и инструменти, съобщения и стартирани подагенти.',
      auditPlaceholder: 'Идентификатор на агент (празно: всички)',
      filter: 'Филтрирай',
      time: 'Време',
      agent: 'Агент',
      event: 'Събитие',
      toolOrModel: 'Инструмент или модел',
      status: 'Статус',
      detail: 'Подробности',
      consoleTitle: 'Конзола за заявки',
      consoleSubtitle: 'Cypher само за четене; записващите заявки се отхвърлят.',
      run: 'Изпълни',
      truncated: 'още редове бяха отрязани',
      graph: {
        clusterPickTitle: "Фокусирай домейн на знанието в графа",
        clusterPickHint: "Клик върху бизнес звено фокусира неговия подграф с ролите и мостовете за предаване в интерактивния граф.",
        allClusters: "Всички домейни (целият граф)",
        activeCluster: "Активен домейн на знанието",
        publicationsTitle: "Публикации в изследователския архив",
        storesTitle: 'Хранилища на фирмената памет',
        storesSubtitle: 'Какво съдържа всяко хранилище на фирмената памет, прочетено на живо: графът в Neo4j, състоянието на Veridion Core в Postgres, векторите на базата знания в Qdrant.',
        storeNeo4j: 'Neo4j (граф)',
        storeNeo4jHolds: 'Фирмената памет: спомени с техния обхват, извлечените от Graphiti обекти и факти с периода им на валидност, работните елементи с тяхното значение, софтуерната работа и одитът на агентите.',
        storePostgres: 'Postgres (релационна)',
        storePostgresHolds: 'Транзакционното състояние на Veridion Core: таблицата на процесите на агентите, пощенските кутии, разговорите, контролните точки, задачите за кодиране, одобренията, организацията и потреблението.',
        storeQdrant: 'Qdrant (вектори)',
        storeQdrantHolds: 'Фирмената база знания: вградените пасажи от документите, добавени от администратор, претърсвани от оркестратора, когато ход от разговора се нуждае от базата знания.',
        nodes: 'възела',
        relationships: 'връзки',
        relationshipType: 'Тип връзка',
        tables: 'таблици',
        table: 'Таблица',
        rows: 'реда',
        purpose: 'Какво съдържа',
        documents: 'документа',
        session: 'Сесия',
        collection: 'Колекция',
        role: 'Роля',
        roleDocuments: 'документи',
        roleCurated: 'подбрани двойки въпрос-отговор',
        title: 'Граф',
        subtitle: 'Графът на фирмената памет в Neo4j: започнете от резултат от търсене, най-новите спомени или работните елементи; щракнете върху възел, за да го прочетете, разгънете съседите му, влачете за подредба, превъртете за мащаб.',
        startNewest: 'Най-нови спомени',
        startWork: 'Работни елементи',
        searchPlaceholder: 'Име, текст или идентификатор за търсене в графа',
        find: 'Търсене',
        noHits: 'Нищо не е намерено.',
        name: 'Име',
        sources: { memory: 'спомен', entity: 'извлечен обект', node: 'проектна памет', episode: 'епизод' },
        show: 'покажи',
        shown: '{nodes} възела и {edges} връзки в графа',
        truncated: 'отрязано на границата; разгънете възел или търсете по-тясно',
        selected: 'Избран възел',
        selectHint: 'Щракнете върху възел в графа.',
        expand: 'Разгъни съседите',
        expandTwo: 'Разгъни две нива',
        centre: 'Центрирай върху този възел',
        facts: 'Факти за този обект',
        degree: 'Връзки',
        direction: 'Посока',
        out: 'изходяща',
        in: 'входяща',
        noRelationships: 'Няма връзки.',
        property: 'Свойство',
        value: 'Стойност',
        noProperties: 'Няма свойства.',
        factsOf: 'Факти за',
        factsSubtitle: 'Какво Graphiti е извлякъл за този обект, с периода на валидност на всеки факт; опроверган факт носи крайна дата.',
        relation: 'Връзка',
        other: 'Друг обект',
        newestTitle: 'Най-нови спомени',
        newestSubtitle: 'Последно записаните спомени с това, за което се отнасят; „покажи“ рисува един с връзките му.',
        about: 'Отнася се за',
        workTitle: 'Работни елементи',
        workSubtitle: 'Всяка потвърдена работа със състояние, отговорник, задача и резултатите от сценариите ѝ; „покажи“ рисува една с нейното значение, задачата, задачите за кодиране и създадените за нея агенти.',
        allStates: 'всички състояния',
        states: { confirmed: 'потвърдена', in_progress: 'в процес', blocked: 'блокирана', done: 'завършена', failed: 'неуспешна', dropped: 'отпаднала' },
        workItem: 'Работен елемент',
        owner: 'Отговорник',
        issue: 'Задача',
        scenarios: 'Сценарии',
        results: { passed: 'преминат', failed: 'неуспешен', pending: 'предстои' },
      },
      day: {
        title: 'Денят на фирмата',
        subtitle: 'Хронологията на събитията, които Veridion Core записва: думите на хората, карти, работа, предавания, проучвания, агенти, задачи за кодиране, проекти, инциденти и срещи, най-новото първо.',
        sinceToday: 'днес',
        sinceDay: 'последните 24 часа',
        sinceWeek: 'последните 7 дни',
        allKinds: 'всички видове',
        refresh: 'Обнови',
        count: '{n} събития',
        time: 'Час',
        actor: 'Участник',
        happening: 'Събитие',
        work: 'Работа',
        empty: 'Нищо не е записано за този период.',
        kinds: { word: 'дума', request: 'искане', card: 'карта', work: 'работа', handover: 'предаване', research: 'проучване', agent: 'агент', task: 'задача за кодиране', project: 'проект', incident: 'инцидент', schedule: 'график', meeting: 'среща', message: 'съобщение' },
      },
    },
    title: 'Административен панел',
    adminKicker: 'Експлоатация',
    smtmStatusTitle: 'Данни и прогнози на SMTM',
    smtmStatusSubtitle: 'Наблюдава времевите редове на брокера, публикуваните модели, изхода от прогнозите и RSS каналите.',
    smtmStatusUnavailable: 'Състоянието на SMTM не е налично',
    smtmGeneratedAt: 'Генерирано на',
    smtmMinimumRows: 'Минимум редове за обучение',
    smtmBaseFrames: 'Базови времеви редове',
    smtmTrainableFrames: 'Суровите данни са готови',
    smtmWaitingHistory: 'Изчаква история',
    smtmPredictionTrackedInstruments: 'Проследявани инструменти',
    smtmPredictionEnabledCount: 'Прогнозите са включени',
    smtmPredictionDisabledCount: 'Прогнозите са спрени',
    smtmMlFrames: 'ML набори от данни',
    smtmOnlineModels: 'Онлайн модели',
    smtmModelsWithArtifacts: 'Модели с артефакти',
    smtmPredictionFrames: 'Редове с прогнози',
    smtmMissingPredictions: 'Редове без прогнози',
    smtmBlobArtifacts: 'Blob артефакти',
    smtmStalePredictions: 'Остарели прогнози',
    smtmRssFrames: 'RSS канали',
    smtmDataframesTotal: 'Общо набори от данни',
    smtmLatestModelUpload: 'Последно качване на модел',
    smtmLatestPredictionWrite: 'Последен запис на прогноза',
    smtmRuntimeHints: 'Бележки за изпълнението',
    smtmNoHints: 'Няма отворени бележки за SMTM.',
    smtmInstrument: 'Инструмент',
    smtmBaseData: 'Базови данни',
    smtmMlFrame: 'ML набор от данни',
    smtmModelPublish: 'Състояние на модела',
    smtmArtifacts: 'Артефакти',
    smtmPredictionFrame: 'Ред с прогнози',
    smtmIssues: 'Проблеми',
    smtmNoIssues: 'Няма проблеми',
    smtmNoFrames: 'Не са намерени инструменти на SMTM.',
    smtmPredictionControlTitle: 'Управление на прогнозите на SMTM',
    smtmPredictionControlSubtitle: 'Решете за всеки инструмент дали SMTM да изчислява нови прогнози с машинно обучение, или само да събира базови данни.',
    smtmPredictionSettingsUnavailable: 'Управлението на прогнозите на SMTM не е налично',
    smtmPredictionControlHint: 'Спрените инструменти запазват историческите си данни. За тях вече не се създават нови ML набори, обучения и прогнози.',
    smtmPredictionMode: 'Режим на прогнозиране',
    smtmPredictionToggle: 'Административно управление',
    smtmPredictionToggleLabel: 'Включете или спрете прогнозите',
    smtmPredictionEnabled: 'Прогнозата е включена',
    smtmPredictionDisabled: 'Прогнозата е спряна',
    smtmPredictionSaving: 'Записване...',
    smtmPredictionSettingsSaved: 'Управлението на прогнозите на SMTM е записано.',
    smtmPredictionSaveChanges: 'Запиши промените',
    smtmPredictionResetChanges: 'Отхвърли промените',
    smtmPredictionPendingChanges: 'чакащи промени',
    smtmPredictionPendingBadge: 'Чака запис',
    smtmOpenAzuriteUi: 'Отвори уеб интерфейса на Azurite',
    azuriteTitle: 'Уеб интерфейс на Azurite (SMTM)',
    azuriteSubtitle: 'Изглед само за четене на записите в modelstatus, blob артефактите и изтеглянията на модели.',
    azuriteModelGroups: 'Групи модели',
    azuriteBlobArtifacts: 'Blob артефакти',
    azuriteFiles: 'Файлове',
    azuriteSearchPlaceholder: 'Филтрирай модели',
    azuriteNoModels: 'Не са намерени модели в Azurite.',
    smtmRows: 'Редове',
    smtmLatest: 'Последна времева отметка',
    smtmAge: 'Възраст',
    smtmValue: 'Стойност',
    smtmMinutesAgo: 'мин. назад',
    smtmMinutesAhead: 'мин. напред',
    smtmHoursAgo: 'ч. назад',
    smtmDaysAgo: 'дни назад',
    smtmStateLabels: {
      available: 'Наличен',
      trainable: 'Готов за обучение',
      waiting_for_history: 'Изчаква история',
      missing_base_data: 'Няма базови данни',
      missing_machine_learning: 'Липсва ML набор от данни',
      missing_prediction: 'Липсва прогноза',
      prediction_disabled: 'Прогнозата е спряна',
      stale_prediction: 'Остаряла прогноза',
      open: 'Отворен',
      completed: 'Завършен',
      online: 'Онлайн',
      offline: 'Офлайн',
      training: 'Обучение',
      uploading: 'Качване',
      failed: 'Неуспешен',
      unknown: 'Неизвестен',
      missing: 'Липсващ'
    },
    smtmIssueLabels: {
      empty_base_frame: 'Базовият времеви ред е празен',
      insufficient_history: 'Недостатъчна история',
      missing_machine_learning_frame: 'Липсва ML набор от данни',
      missing_prediction_frame: 'Липсва ред с прогнози',
      stale_prediction_frame: 'Редът с прогнози е остарял',
      missing_online_model: 'Няма онлайн модел',
      model_offline: 'Моделът е офлайн',
      missing_model_blob: 'Липсва blob на модела',
      missing_model_header: 'Липсва заглавна част на модела',
      missing_modelstatus_entry: 'Липсва запис в modelstatus',
      inference_not_writing_prediction: 'Изводът не записва прогнози',
      prediction_disabled_by_admin: 'Прогнозата е спряна от администратор'
    },
    smtmHintLabels: {
      trainable_frames_missing_predictions: 'готови инструменти без изход от прогнози',
      instruments_waiting_for_history: 'инструменти, които още чакат история',
      models_missing_artifacts: 'онлайн модели без пълни артефакти',
      no_online_models: 'Няма онлайн модели в Azurite',
      azurite_unavailable: 'Състоянието на хранилището Azurite в момента не е налично'
    },
    mailTitle: 'Конфигурация на пощата',
    usersTitle: 'Управление на потребители',
    usersSubtitle: 'Профили, роли, статус и 2FA от Keycloak. Изборът на профил отваря управлението точно за него.',
    usersHideCreate: 'Затвори формуляра',
    usersCreateHint: 'Новият профил започва със задължителна 2FA и става активен веднага след нейната настройка.',
    usersFilterAllStatus: 'Всички състояния',
    usersFilterAllRoles: 'Всички роли',
    usersManage: 'Управлявай',
    usersClose: 'Затвори',
    usersNoneFound: 'Не са намерени потребители.',
    usersPagePrev: 'Назад',
    usersPageNext: 'Напред',
    auditTitle: 'Одитен дневник',
    smtpHost: 'SMTP сървър',
    smtpPort: 'SMTP порт',
    smtpSecurity: 'SMTP защита',
    smtpUsername: 'SMTP потребител',
    smtpPassword: 'SMTP парола',
    fromEmail: 'Адрес на подателя',
    fromName: 'Име на подателя',
    replyToEmail: 'Адрес за отговор',
    saveMailSettings: 'Запиши настройките на пощата',
    sendTestMail: 'Изпрати тестово писмо',
    createUser: 'Създай потребител',
    setPassword: 'Задай парола',
    setRoles: 'Задай роли',
    setStatus: 'Задай статус',
    resetMfa: 'Нулирай 2FA',
    revokeSessions: 'Прекрати сесиите',
    filterUsers: 'Филтрирай потребители',
    testRecipient: 'Получател на тестовото писмо',
    statusConfigured: 'Конфигурирано',
    statusMissing: 'Не е конфигурирано',
    userEmail: 'Имейл',
    userName: 'Потребителско име',
    userRoles: 'Роли',
    userStatus: 'Статус',
    auditEvent: 'Събитие',
    auditCreatedAt: 'Създадено на',
    auditDetails: 'Подробности',
    aiGatewayTitle: 'AI Gateway',
    aiGatewayEndpoint: 'Крайна точка',
    aiGatewayIdentitySource: 'Идентичност от claim на токена',
    aiGatewayBudgetSource: 'Начални стойности в',
    aiGatewayModels: 'Маршрутизирани модели',
    aiGatewayModel: 'Модел',
    aiGatewayBackend: 'Бекенд',
    aiGatewayBudgets: 'Бюджети за токени',
    aiGatewayIdentity: 'Идентичност',
    aiGatewayTokenBudget: 'Бюджет за токени',
    aiGatewayWindow: 'Прозорец',
    aiGatewayAnyIdentity: 'всяка идентичност',
    aiGatewayAnyModel: 'всеки модел',
    aiUsageWindowStarted: 'Прозорец от',
    aiUsageRemaining: 'Остатък',
    aiUsageIdentities: 'Идентичности',
    aiGatewaySubtitle: 'Envoy AI Gateway е единственият път до модел: маршрутизираните модели, обслужващите ги бекенди и бюджетът за токени на всяка идентичност.',
    aiGatewayHint: 'Бюджетите се управляват тук. Слоят за внедряване само задава началните стойности за нов клъстер.',
    aiUsageTitle: 'Потребление на ИИ по идентичност',
    aiUsageSubtitle: 'Токени, отчетени от шлюза в текущия прозорец.',
    sessionActiveUsers: 'Влезли потребители',
    sessionActiveSessions: 'Активни сесии',
    sessionMfaSessions: 'Потвърдени сесии',
    aiUsageTotalTokens: 'Общо токени',
    aiServicesTitle: 'Достъп до услуги',
    aiServicesSubtitle: 'Връзки към API и оперативните интерфейси на платформата; всяка цел сама проверява администраторската роля.',
    aiMailSubtitle: 'SMTP настройките, с които Keycloak изпраща писма за потвърждение и нулиране, и тестовото изпращане.',
    tabOverview: 'Преглед',
    tabSmtm: 'SMTM',
    tabEnvoy: 'Envoy AI Gateway',
    tabMail: 'Изпращане на имейли',
    tabUsers: 'Потребители',
    tabAudit: 'Одитен дневник',
    tabServiceLinks: 'Достъп до услуги',
    tabVeridion: 'Veridion SMTM',
    tabVeridionPaioneer: 'Veridion pAIoneer Labs GmbH',
    tabAgenticRag: 'Agentic RAG',
    tabPlatform: 'Платформа',
    platformTitle: 'Състояние на платформата',
    platformSubtitle: 'Всяко работно натоварване на pAIoneer Labs GmbH с готовите му реплики, рестарти и образ, направо от Kubernetes.',
    platformHostPage: 'Управление на инстанциите в хоста на приложения',
    openVisitorMonitoring: 'Отвори мониторинг на посетители, маркетинг и SEO',
    platformUnavailable: 'Състоянието на платформата не е налично',
    platformWorkloadsTotal: 'Работни натоварвания',
    platformDegradedTotal: 'Не са готови',
    platformRestartsTotal: 'Рестарти',
    platformWorkload: 'Работно натоварване',
    platformNamespace: 'Именувано пространство',
    platformReplicas: 'Реплики',
    platformRestarts: 'Рестарти',
    platformImage: 'Образ',
    platformState: 'Състояние',
    platformStateReady: 'Готово',
    platformStateDegraded: 'Влошено',
    platformStateDown: 'Спряно',
    platformStateUnknown: 'Неизвестно',
    platformNodes: 'Възли',
    platformOsImage: 'Операционна система',
    platformKernel: 'Ядро',
    platformRuntime: 'Среда за контейнери',
    platformKubelet: 'Kubelet',
    platformUsed: 'Използва се сега',
    platformReportedCapacity: 'Отчетено от Kubernetes',
    platformConfiguredCap: 'Зададен лимит на контейнера',
    platformPressure: 'Условия на натиск',
    platformPressureNone: 'няма',
    platformCpu: 'CPU ядра',
    platformNoWorkloads: 'Това именувано пространство съдържа конфигурационни обекти, без работни натоварвания.',
    platformMemory: 'Памет',
    platformEvents: 'Последни предупреждения',
    platformEventsNone: 'Няма предупреждения.',
    platformEventObject: 'Обект',
    platformEventReason: 'Причина',
    platformEventMessage: 'Съобщение',
    platformEventLastSeen: 'Последно видяно',
    platformMetricsMissing: 'Няма данни за потреблението: metrics-server не отговаря.',
    aiGatewayBackends: 'Обслужващи бекенди',
    gpuTitle: 'Видеокарта',
    gpuNote: 'Натоварване на двигателите на видеокартата, взетите от тях токени по идентичност и по бот в Webex и бюджетите за токени по идентичност и двигател.',
    gpuTokensWindow: 'Токени на видеокартата в прозореца',
    gpuSinceStart: 'от старта на двигателя',
    gpuIdentities: 'По идентичност, текущ прозорец',
    gpuBots: 'По бот в Webex и агент, 30 дни',
    gpuBot: 'Бот в Webex / агент',
    gpuBudgetTitle: 'Бюджет по идентичност за двигателя',
    gpuBudgetSet: 'Задаване на бюджет',
    gpuBudgetHint: 'Токени на час на двигателя; шлюзът го прилага. Ограничава и идентичност без лимит.',
    gpuNoneYet: 'Още нищо не е отчетено.',
    gpuEngines: 'Двигатели',
    gpuEngine: 'Двигател',
    gpuEngineGold: 'Златен двигател',
    agenticRagTitle: 'Agentic RAG',
    agenticRagSubtitle: 'Среда на изпълнение, база знания, подготовка на обучението и проследимост на приложението Agentic RAG.',
    agenticRagBackendStatus: 'Състояние на бекенда',
    agenticRagRuntimeMode: 'Режим на изпълнение',
    agenticRagKnowledgeMode: 'Режим на знанията',
    agenticRagDeploymentEnv: 'Среда на разполагане',
    agenticRagVectorStores: 'Векторни хранилища',
    agenticRagQdrantStatus: 'Qdrant',
    agenticRagQdrantCollection: 'Колекция документи',
    agenticRagQdrantCuratedCollection: 'Колекция с подбрани въпроси и отговори',
    agenticRagQdrantDashboard: 'Табло',
    agenticRagPhoenixStatus: 'Phoenix',
    agenticRagOpenDocs: 'Отваряне на Swagger',
    agenticRagOpenPhoenix: 'Отваряне на Phoenix',
    agenticRagOpenQdrant: 'Отваряне на Qdrant',
    agenticRagKnowledgeTitle: 'База знания',
    agenticRagKnowledgeSubtitle: 'Състояние на документите и подбраните въпроси и отговори на приложението Agentic RAG.',
    agenticRagDocuments: 'Документи',
    agenticRagCuratedQaPairs: 'Подбрани двойки въпрос-отговор',
    agenticRagTrainingTitle: 'Подготовка на обучението',
    agenticRagTrainingSubtitle: 'Последното изпълнение на генератора и последното състояние на обучителя.',
    agenticRagLatestDataset: 'Последен набор от данни',
    agenticRagDatasetPairs: 'Двойки въпрос-отговор',
    agenticRagDatasetDocuments: 'Обработени документи',
    agenticRagDatasetModifiedAt: 'Последна промяна',
    agenticRagLatestTrainerInput: 'Последен вход на обучителя',
    agenticRagTrainerInputModifiedAt: 'Входът е променен',
    agenticRagLatestTrainerRun: 'Последно изпълнение на обучителя',
    agenticRagTrainerRunModifiedAt: 'Обобщението на изпълнението е променено',
    gpuEngineSilver: 'Сребърен двигател',
    gpuAssignment: 'Разпределение',
    gpuWho: 'Кой',
    gpuRank: 'Ранг',
    gpuRankHint: 'Ранг 0 се обслужва първи; всеки двигател обслужва по ранг.',
    gpuLanes: 'Текущи извиквания на Veridion Core по двигател и ранг',
    gpuInFlight: 'в ход',
    gpuWhoMainBotPeople: 'Главен бот: разговори с хора',
    gpuWhoMainBotJudgements: 'Главен бот: преценки в същия ход',
    gpuWhoAutopilot: 'Автопилот',
    gpuWhoAgents: 'Агенти, които главният бот изпълнява',
    gpuWhoArchitect: 'Архитект',
    gpuWhoChair: 'Председател на срещата',
    gpuWhoOrchestrator: 'Оркестратор на фирмената инстанция',
    gpuWhoColleagues: 'ИИ колеги: ходове и техните преценки',
    gpuWhoMeetingWords: 'ИИ колеги: изказвания в срещите',
    gpuWhoBackgroundReading: 'Фонова услуга: четене на публикациите на ботовете',
    gpuWhoMemory: 'Фирмена памет: приемане и резюмета',
    gpuWhoCoding: 'Задачи за кодиране: преценки и учене',
    gpuWhoResearch: 'Уеб и OSINT проучване',
    gpuWhoKnowledgeBase: 'Фирмена база знания: четене на сканирани страници',
    gpuWhoPipeline: 'Проверка на пайплайна спрямо IDD',
    gpuWhoSmtm: 'Veridion SMTM: чатът и базата знания на SaaS, последен ранг',
    gpuUnavailable: 'Видеокартата не отговаря',
    aiGatewaySource: 'Източник',
    aiSourceGpu: 'Видеокарта',
    aiGatewayMeter: 'Брояч',
    aiGatewayMeterIdentity: 'Всяка идентичност, преброена',
    aiGatewayEngines: 'Двигатели на видеокартата',
    aiGatewayEnginesHint: 'Текущи показатели на всеки двигател от неговите метрики: изпълнявани и чакащи заявки, запълване на кеша и обслужени токени от стартирането.',
    aiEngineRunning: 'Текущи',
    aiEngineWaiting: 'Чакащи',
    aiEngineCache: 'Зает кеш',
    aiEngineServed: 'Обслужени токени',
    aiEngineIdle: 'Няма заявки',
    aiEngineUnavailable: 'Двигателят не отговаря',
    aiGatewayServing: 'Готов',
    aiBudgetControlTitle: 'Управление на бюджетите за токени',
    aiBudgetControlSubtitle: 'Бюджетът по подразбиране важи за всяка идентичност. Отделна идентичност може да получи собствен таван.',
    aiBudgetDefault: 'Бюджет по подразбиране',
    aiBudgetIdentity: 'Идентичност',
    aiBudgetTokens: 'Токени',
    aiBudgetApply: 'Приложи',
    aiBudgetAdd: 'Задай таван',
    aiBudgetRemove: 'Премахни',
    aiBudgetSaved: 'Бюджетът за токени е приложен.',
    aiBudgetIdentityPlaceholder: 'Клиентски идентификатор, напр. paioneer-agent-veridion-smtm',
    aiBudgetUnlimited: 'Без лимит',
    aiBudgetSetUnlimited: 'Премахни лимита',
    aiBudgetRestoreLimit: 'Възстанови лимита',
    aiUsageReset: 'Изчисти прозореца',
    aiUsageResetDone: 'Текущият прозорец е изчистен.',
    userMfa: '2FA',
    userMfaOn: 'Конфигурирана',
    userMfaOff: 'Липсва',
    userCreatedAt: 'Създаден',
    mailSource: 'Управлява се в',
    veridionTitle: 'Veridion SMTM',
    veridionSubtitle: 'Разговорното ядро на търговския асистент: среда за изпълнение, регистър на инструментите, MCP сървъри и активност.',
    veridionOpenPage: 'Отвори Veridion',
    veridionOpenDocs: 'Отвори Swagger',
    veridionCoreStatus: 'Veridion MCP orchestrator',
    veridionTools: 'Инструменти',
    veridionToolsTitle: 'Регистър с инструменти',
    veridionToolsSubtitle: 'Показва заредените фамилии инструменти и действителното им състояние.',
    veridionToolName: 'Инструмент',
    veridionToolRuntime: 'Среда',
    veridionToolRisk: 'Риск',
    veridionToolEnabled: 'Включен',
    veridionNoTools: 'Не са заредени инструменти на Veridion.',
    veridionRuntimeProfiles: 'Профили на средата',
    veridionRegistryReloaded: 'Регистърът е презареден',
    veridionProvider: 'Път на ИИ',
    veridionMcpTitle: 'MCP сървъри',
    veridionMcpSubtitle: 'Свързани външни сървъри за инструменти с тяхното състояние и брой инструменти.',
    veridionMcpServer: 'Сървър',
    veridionMcpState: 'Състояние',
    veridionMcpTools: 'Инструменти',
    veridionMcpLastSuccess: 'Последно достъпен',
    veridionMcpConnected: 'свързан',
    veridionMcpUnreachable: 'недостъпен',
    veridionMcpDisabled: 'изключен',
    veridionMcpEmpty: 'Няма конфигурирани MCP сървъри.',
    veridionActivityTitle: 'Поток на активността',
    veridionActivitySubtitle: 'Структурирани събития по време на изпълнение от оркестратора и неговите инструменти.',
    veridionActivityEmpty: 'Още няма записана активност.',
    veridionActivitySource: 'Източник',
    veridionActivitySurface: 'Повърхност',
    veridionActivityEvent: 'Събитие',
    veridionActivityTool: 'Инструмент',
    veridionActivityStatus: 'Статус',
    veridionActivitySummary: 'Резюме',
    veridionUnavailable: 'Veridion в момента не е достъпен.',
    veridionNotConfigured: 'Veridion още не е напълно конфигуриран в средата на Homepage.',
    veridionRequestFailed: 'Veridion не изпълни успешно заявеното административно повикване.',
    companyTitle: 'Veridion pAIoneer Labs GmbH',
    companySubtitle: 'Инстанцията на Veridion на pAIoneer Labs GmbH за служителите в Webex, с YouTrack и собствена база знания; нейните извиквания на модели минават през Envoy AI Gateway.',
    companyWorkloads: 'Работни натоварвания',
    companyTokensWindow: 'Токени в текущия прозорец',
    companyBudget: 'Бюджет',
    companyBudgetDefault: 'бюджет по подразбиране',
    companyCost30: 'Разходи за последните 30 дни',
    openrouterTitle: 'Таксувано от OpenRouter',
    openrouterRemaining: 'Оставащ кредит',
    openrouterOf: 'от',
    openrouterToday: 'Днес',
    openrouterWeek: 'Тази седмица',
    openrouterMonth: 'Този месец',
    openrouterUnavailable: 'OpenRouter не може да бъде прочетен в момента',
    openrouterNote: 'Фактурирането от OpenRouter за ключа на платформата, в щатски долари; ден и седмица по UTC. Осчетоводените стойности по-долу отчитат само отговори, които съобщават цената си, затова са по-ниски.',
    companyRequests30: 'Извиквания на модела за последните 30 дни',
    companyCostNote: 'Разходи в щатски долари, както OpenRouter ги отчита за всяка заявка; токените Envoy AI Gateway записва на идентичността {identity}.',
    companyCostNotReported: 'не е отчетено',
    companyPartUnavailable: 'недостъпно',
    companyWebexTitle: 'Webex бот',
    companyWebexSubtitle: 'Webex извиква webex.paioneer-labs.eu/hook; мостът проверява подписа и подателя и предава на Veridion само разрешени съобщения.',
    companyWebexBot: 'Бот',
    companyWebexWebhook: 'Уебхук',
    companyWebexRegistered: 'регистриран',
    companyWebexNotRegistered: 'нерегистриран',
    companyWebexAccess: 'Разрешени',
    companyWebexAnswered: 'Отговорени',
    companyWebexRejected: 'Отхвърлени',
    companyWebexFailed: 'Неуспешни',
    companyWebexRecent: 'Последни доставки',
    companyWebexTime: 'Час',
    companyWebexOutcome: 'Резултат',
    companyWebexReason: 'Причина',
    companyWebexSender: 'Подател',
    companyWebexEmpty: 'Няма доставки от последното стартиране.',
    companyWebexNotConfigured: 'Мостът на Webex е недостъпен или ключът му за състояние липсва в администраторския API.',
    companyUsageTitle: 'Използване по лица',
    companyUsageSubtitle: 'Извиквания на модела, токени и разходи за последните 30 дни от регистъра за използване на инстанцията.',
    companyUsagePerson: 'Лице',
    companyUsageCalls: 'Извиквания',
    companyUsageTokens: 'Токени',
    companyUsageCost: 'Разходи (USD)',
    companyUsageEmpty: 'Няма извиквания на модела през последните 30 дни.',
    companyWebexSendTitle: 'Пиши като бота',
    companyWebexSendPerson: 'До човек',
    companyWebexSendRoom: 'В стая на бота',
    companyWebexSendEmail: 'Имейл адрес в Webex',
    companyWebexSendText: 'Съобщение (Markdown)',
    companyWebexSendButton: 'Изпрати',
    companyWebexSendDone: 'Изпратено.',
    companyWebexSendFailed: 'Неуспешно',
    companyWebexRooms: 'Стаи на бота',
    companyWebexRoomGroup: 'група',
    companyWebexRoomDirect: 'директна',
    companyWebexRoomsEmpty: 'Ботът все още не е в нито една стая.',
    companyKnowledgeTitle: 'База знания',
    companyKnowledgeSubtitle: 'Документите в базата знания на фирмената инстанция (Agentic RAG); оркестраторът търси в тях, когато стъпка от разговора ги изисква. Phoenix записва всяко търсене.',
    companyKnowledgeDocument: 'Документ',
    companyKnowledgeSize: 'Размер',
    companyKnowledgeModified: 'Добавен',
    companyKnowledgeDelete: 'Премахни',
    companyKnowledgeDeleteConfirm: 'Да се премахне ли {name} от базата знания?',
    companyKnowledgeUpload: 'Добави документ',
    companyKnowledgeUploading: 'Качване …',
    companyKnowledgeIntake: 'Обработка',
    companyKnowledgePhoenix: 'Explainable AI (Phoenix)',
    companyKnowledgeEmpty: 'Базата знания е празна.',
    companyKnowledgeNotConfigured: 'Базата знания не е свързана с администраторския API.',
    companyGuestsTitle: 'Гости с достъп',
    companyGuestsHint: 'Всеки адрес от {domains} може да използва бота. Отделни външни адреси администраторите добавят тук; промяната важи веднага.',
    companyGuestsEmail: 'Имейл адрес',
    companyGuestsAdd: 'Добавяне',
    companyGuestsRemove: 'Премахване',
    companyGuestsRemoveConfirm: 'Да се отнеме ли достъпът на {email} до бота?',
    companyGuestsAddedBy: 'Добавен от',
    companyGuestsAddedAt: 'Добавен на',
    companyGuestsEmpty: 'Няма въведени гости.',
    companyGuestsNotPersistent: 'Списъкът не се запазва: мостът няма директория за данни.',
    companyGuestsLoadFailed: 'Запазеният списък не можа да се прочете; до следващата промяна никой гост няма достъп.',
    companyErrorRecipientNotAllowed: 'Този адрес не може да отговаря на бота. Първо го добавете като гост, после изпратете.',
    companyErrorDomainAllowed: 'Адресите от този домейн вече имат достъп.',
    companyErrorInvalidEmail: 'Невалиден имейл адрес.',
    companyErrorAlreadyListed: 'Този адрес вече е в списъка.',
    companyErrorStoreUnwritable: 'Списъкът не можа да бъде запазен.',
    smtmFilterTitle: 'Филтър за инструменти на SMTM',
    smtmFilterSubtitle: 'Празно поле показва всички инструменти; няколко имена на инструменти се разделят със запетая, например EUR-USD_FOREX_intraday_data_l1,BitcoinEUR_CRYPTO_intraday_data_l1.',
    smtmFilterPlaceholder: 'Имена на инструменти, разделени със запетая',
    smtmFilterApply: 'Приложи филтъра',
    smtmFilterClear: 'Изчисти филтъра',
    smtmReportingTitle: 'Отчитане на сигналите на SMTM',
    smtmReportingSubtitle: 'Показва квалифицираните сигнали за покупка, оценката им при изход и статуса на доставка на автоматичните известия.',
    smtmReportingUnavailable: 'Отчитането на SMTM не е налично',
    smtmReportingQualifiedSignals: 'Квалифицирани сигнали',
    smtmReportingOpenSignals: 'Отворени сигнали',
    smtmReportingResolvedSignals: 'Приключени сигнали',
    smtmReportingWins: 'Печалби',
    smtmReportingLosses: 'Загуби',
    smtmReportingWinRate: 'Дял на успеха',
    smtmReportingAverageActualReturn: 'Средна реална доходност',
    smtmReportingNetActualReturn: 'Нетна реална доходност',
    smtmReportingDeliveryFailed: 'Неуспешни доставки',
    smtmReportingEntryTime: 'Час на вход',
    smtmReportingExitTime: 'Час на изход',
    smtmReportingExpectedReturn: 'Очаквана доходност',
    smtmReportingActualReturn: 'Реална доходност',
    smtmReportingSignalStatus: 'Статус на сигнала',
    smtmReportingNoSignals: 'Още няма записани квалифицирани сигнали.',
    smtmReportingPendingDeliveries: 'Чакащи доставки',
    smtmReportingFailedDeliveries: 'Неуспешни доставки',
    smtmReportingDeliveryError: 'Грешка при доставка',
    smtmTrainingTitle: 'Обучение и модели на SMTM',
    smtmTrainingSubtitle: 'Показва качеството на обучението, състоянието на моделите и артефактите, публикувани от услугата за обучение.',
    smtmTrainingUnavailable: 'Обучението на SMTM не е налично',
    smtmTrainingModels: 'Модели',
    smtmTrainingOnlineModels: 'Онлайн модели',
    smtmTrainingFailedModels: 'Неуспешни модели',
    smtmTrainingStaleModels: 'Остарели модели',
    smtmTrainingAverageMae: 'Средно MAE',
    smtmTrainingAverageRmse: 'Средно RMSE',
    smtmTrainingAverageR2: 'Средно R²',
    smtmTrainingAverageMase: 'Средно MASE',
    smtmTrainingAverageHitRate: 'Среден дял верни посоки',
    smtmTrainingHitRate: 'Дял верни посоки',
    smtmTrainingLastSuccess: 'Последно успешно обучение',
    smtmTrainingResolution: 'Разделителна способност / хоризонт',
    smtmTrainingConsoleTitle: 'Конзола за обучение на SMTM',
    smtmTrainingConsoleSubtitle: 'Изходът на услугата за обучение на живо.',
    smtmTrainingConsoleUnavailable: 'Конзолата за обучение на SMTM не е налична',
    smtmTrainingConsoleEmpty: 'Още няма изход от обучението.',
    smtmRuntimeTitle: 'Среда на SMTM',
    smtmRuntimeSubtitle: 'Глобален хоризонт, състояние на преизграждането и портал за прогнози на работещата система SMTM.',
    smtmRuntimeUnavailable: 'Средата на SMTM не е налична',
    smtmRuntimeForecastHorizon: 'Хоризонт на прогнозата',
    smtmRuntimeResolution: 'Разделителна способност',
    smtmRuntimeConfigVersion: 'Версия на конфигурацията',
    smtmRuntimePredictionGate: 'Портал за прогнози',
    smtmRuntimeRebuild: 'Преизграждане',
    smtmRuntimeStateOpen: 'отворен',
    smtmRuntimeStateClosed: 'затворен',
    smtmRuntimeStateActive: 'активно',
    smtmRuntimeStateIdle: 'в покой',
    smtmRuntimeForecastHorizonMinutes: 'Минути на хоризонта на прогнозата',
    smtmRuntimeResolutionMinutes: 'Минути на разделителната способност',
    smtmRuntimeRequireCompletedBars: 'Изисквай завършени свещи',
    smtmRuntimePredictionGateOpen: 'Порталът за прогнози е отворен',
    smtmRuntimeRebuildActive: 'Преизграждането е активно',
    smtmRuntimeSaving: 'Записване на средата...',
    smtmRuntimeSave: 'Запиши настройките на средата',
    smtmRuntimeReset: 'Отхвърли промените в средата',
    smtmRuntimeSaved: 'Настройките на средата на SMTM са записани.',
    smtmTrainingRows: 'Редове за обучение / тест',
    smtmTrainingMetrics: 'Метрики',
    smtmTrainingIssues: 'Проблеми при обучението',
    smtmTrainingLlmFeatures: 'LLM характеристики',
    smtmTrainingNoModels: 'Още няма кеширани модели за обучение.',
    smtmDirection: 'Посока',
    smtmSentiment: 'Настроение',
    smtmDeliveryStage: 'Етап',
    smtmDeliveryRecipient: 'Получател',
    mailSettingsSaved: 'Настройките на пощата са записани.',
    mailTestSent: 'Тестовото писмо е изпратено.',
    userCreatedSuccess: 'Потребителят е създаден успешно.',
    userUpdatedSuccess: 'Потребителят е обновен успешно.',
    userDeletedSuccess: 'Потребителят е изтрит успешно.',
    deleteUser: 'Изтрий потребителя',
    roleLabels: {
      admin: 'Администратор',
      pro: 'Pro',
      tester: 'Тестер',
      user: 'Потребител'
    },
    statusLabels: {
      pending_email_verification: 'Чака потвърждение по имейл',
      pending_mfa: 'Чака 2FA',
      active: 'Активен',
      locked: 'Заключен',
      disabled: 'Деактивиран'
    }
  },
  footer: { managingDirectors: 'Управители', servicesTitle: 'Услуги', legal: { title: 'Правни въпроси', imprint: 'Правна информация', privacy: 'Поверителност', aiTransparency: 'Прозрачност относно ИИ', cookieSettings: 'Настройки на бисквитките', terms: 'Общи условия' }, copyright: 'Всички права запазени.' },
  auth: { validating: 'Валидация...', errors: { registrationFailed: 'Регистрацията е неуспешна: ', unknownError: 'Неизвестна грешка' } },
  account: { username: 'Потребителско име', email: 'Имейл', roles: 'Роли', manageText: 'Паролата, двуфакторното удостоверяване, активните сесии и имейл адреса променяте в управлението на профила.', manageButton: 'Отваряне на управлението на профила', signedOut: 'Не сте влезли в профила си.' },
  cookies: {
    title: 'Настройки за поверителност',
    description: 'Анализираме статистиката на посещенията с методи на машинното обучение, за да подобряваме нашия уебсайт. С Вашето съгласие обработваме за тази цел данни за използването и устройството, включително IP адреса Ви, и разпознаваме браузъра Ви при следващи посещения. Съгласието е доброволно и може да бъде оттеглено по всяко време от „{settings}“. Подробности, включително за предаване към трети държави, ще намерите в политиката за поверителност.',
    necessary: {
      title: 'Необходими',
      description: 'Нужни за работата на уебсайта, например изборът на език и запазването на този избор.'
    },
    statistics: {
      title: 'Статистика',
      description: 'Прегледи на страници и използване на уебсайта, без разпознаване и без съхраняване на IP адреса.'
    },
    marketing: {
      title: 'Анализ и машинно обучение',
      description: 'Разпознаване при следващи посещения и анализ на IP адреса (приблизително местоположение, мрежов оператор, организация) и на характеристиките на устройството; съхраняване до дванадесет месеца след последното посещение. При това IP адресът Ви се предава и на интернет регистри в САЩ, Австралия и Мавриций, за които не е установено адекватно ниво на защита на данните; съществува риск от достъп на местните органи и от затруднено упражняване на правата Ви.'
    },
    acceptAll: 'Приемане на всички',
    rejectAll: 'Само необходимите',
    settings: 'Настройки',
    save: 'Запазване на избора',
    alwaysOn: 'Винаги активни'
  },
  pages: {
    teaching: { hero: { title: 'Обучения по периферен ИИ (Edge AI) и EU AI Act', subtitle: 'Консултиране по ИИ за предприятия • Разработка на периферни решения • Правно сигурно внедряване' }, intro: 'Специализирани обучения по ИИ за висши ръководители, ръководители на проекти и екипи за разработка. От стратегическо консултиране до техническо внедряване – в съответствие с EU AI Act.', eu_ai_act: { title: 'Съответствие с EU AI Act и периферни изчисления (Edge Computing)', subtitle: 'Правно сигурно внедряване на ИИ с локална обработка на данните', description: 'EU AI Act определя строги правила за използването на изкуствен интелект в Европа. Периферните изчисления предлагат идеалното решение: чувствителните данни остават локално, постигането на съответствие се опростява, а контролът върху ИИ системите остава във Ваши ръце.', benefits: ['Защита на данните чрез локална обработка', 'По-малка сложност при осигуряване на съответствие', 'Пълен контрол върху решенията на ИИ', 'Прозрачност и проследимост', 'Минимизирани правни рискове', 'Независимост от доставчици на облачни услуги'], highlight: 'Периферни изчисления + EU AI Act = правно сигурен ИИ без компромиси' }, offerings: { title: 'Предлагани курсове', categories: [{ title: 'Изкуствен интелект и машинно обучение', icon: 'brain', topics: ['Генеративен ИИ и големи езикови модели (периферия и облак)', 'Класическо машинно обучение (оптимизирано за периферни устройства)', 'Дълбоко обучение и невронни мрежи (внедряване на периферията)', 'Компютърно зрение и NLP (решения за периферни устройства)', 'RAG системи и фина настройка на LLM (периферия и облак)', 'Автономни ИИ агенти (периферни изчисления)', 'Съответствие с EU AI Act и правна сигурност'] }, { title: 'Наука за данните и статистика', icon: 'chart', topics: ['Описателна и инференциална статистика', 'Моделиране и анализ на данни', 'Анализ на времеви редове', 'Иконометрия за стопански и икономически специалности', 'Биостатистика за природните науки', 'A/B тестване и планиране на експерименти'] }, { title: 'Софтуерна архитектура и сигурност', icon: 'shield', topics: ['Модулни архитектури', 'Слаба свързаност и чист код', 'Проектиране на микроуслуги', 'ИТ сигурност и нормативно съответствие', 'DevOps и CI/CD', 'Облачни архитектури'] }] }, target_groups: { title: 'Целеви групи', groups: [{ title: 'Висше ръководство и вземащи решения', description: 'Стратегическо консултиране по ИИ, анализ на разходите и инвестиционни решения', formats: ['Брифинги за ръководството', 'Анализи на възвръщаемостта (ROI)', 'Стратегическо консултиране'], focus: 'Бизнес казуси, съответствие с EU AI Act, планиране на бюджета' }, { title: 'Ръководители на проекти и мениджъри', description: 'Управление на ИИ проекти, избор на технологии и стратегии за внедряване', formats: ['Уъркшопи за мениджъри', 'Оценки на технологии', 'Разработване на пътна карта'], focus: 'Планиране на проекти, избор на доставчици, управление на риска' }, { title: 'ИТ разработчици и инженери', description: 'Практическа разработка на периферен ИИ, техническа реализация и внедряване', formats: ['Задълбочени технически сесии', 'Прегледи на код', 'Уъркшопи по архитектура'], focus: 'Периферни изчисления, фина настройка на LLM, системна интеграция' }, { title: 'Специалисти от бизнес звената', description: 'Разбиране на ИИ, техники за съставяне на промптове и практическо приложение в ежедневната работа', formats: ['Обучения за потребители', 'Уъркшопи по съставяне на промптове', 'Разработване на случаи на употреба'], focus: 'Практическо приложение, интеграция в работните процеси, повишаване на продуктивността' }, { title: 'Студенти и академични специалисти', description: 'Университетско преподаване, индивидуални занимания и научно ръководство на проекти', formats: ['Лекции', 'Индивидуални занимания', 'Ръководство на дипломни работи'], focus: 'Статистика, иконометрия, изследователски методи' }] }, expertise: { title: 'Техническа експертиза', items: ['Разработване на стратегически пътни карти за ИИ за предприятия', 'Системи за периферен ИИ с RAG/GRAG архитектури и фина настройка с LoRA/QLoRA', 'Стратегии за съответствие с EU AI Act и правно сигурно внедряване', 'Анализи на възвръщаемостта (ROI) и планиране на инвестициите за ИИ проекти', 'Автономни ИИ агенти с набори от инструменти и способности за разсъждение', 'Управление на промяната при въвеждането на ИИ в организациите', 'Стратегии за облак и собствена инфраструктура (Azure, STACKIT)', 'Промпт инженеринг и оптимизация на работните процеси'] }, technologies: { title: 'Технологичен стек', list: 'Python, R, PyTorch, TensorFlow, CUDA, Docker, React, Azure, STACKIT, JupyterLab, Google Colab, Hugging Face, SPSS, Stata' }, clients: { title: 'Отрасли и институции', sectors: ['Здравноосигурителни каси', 'Издателства', 'Банки и финтех', 'Индустрия и IoT', 'Научни изследвания и университети', 'Консултантски услуги', 'Стартъпи'] }, workshops: { title: 'Формати', formats: [{ title: 'Брифинг за ръководството', duration: '2-4 часа', description: 'Стратегически преглед за ръководството с фокус върху възвръщаемостта (ROI) и EU AI Act' }, { title: 'Уъркшоп за мениджъри', duration: '1-2 дни', description: 'Обучение за ръководители на проекти по внедряване на ИИ и управление на промяната' }, { title: 'Задълбочена техническа сесия', duration: '2-5 дни', description: 'Практическа разработка на периферен ИИ за ИТ екипи и инженери' }, { title: 'Обучение за потребители', duration: '0,5-1 ден', description: 'Практическо приложение на ИИ за специалисти от бизнес звената' }, { title: 'Индивидуален коучинг', duration: 'При необходимост', description: 'Лична подкрепа и съдействие по проекти' }] }, sidebar: {languagesLabel: 'Езици:', languagesValue: 'DE / EN / NL', focusLabel: 'Фокус:', specializationTitle: 'Специализация', specializationItems: ['Периферен ИИ за локална обработка на данни без зависимост от облака', 'Внедряване в съответствие с EU AI Act за правна сигурност'], benefitsTitle: 'Предимства', benefits: ['Съобразено с целевата група', 'Приложимо веднага', 'С фокус върху възвръщаемостта', 'Дистанционно или на място'] }, cta: { title: 'Готови ли сте за стратегическа трансформация с ИИ?', description: 'От консултиране на ръководството до техническо внедряване – нека обсъдим конкретните Ви изисквания.', button: 'Заявете консултация', email: 'info@paioneer.eu', subject: 'Запитване за обучение' } },
    agenticdev: { seo: { title: 'Intent-Driven Development (IDD) за агентно програмиране | pAIoneer Labs GmbH', description: 'Intent-Driven Development прави софтуерната разработка с помощта на ИИ управляема: смисълът, решенията и сценариите се превръщат в оперативни артефакти за агентното програмиране.', keywords: 'Intent-Driven Development, Intent Driven Development, IDD, агентно програмиране, Agentic Coding, агентна софтуерна разработка, софтуерна разработка с помощта на ИИ, Vibe Coding, Spec-Driven Development, промпт инженеринг, инженеринг на изискванията с ИИ', ogTitle: 'Intent-Driven Development: смисъл преди реализация', ogDescription: 'IDD операционализира контекста, преди да бъде написан код: Intent, Decisions и Scenarios стават проектната памет на агентната софтуерна разработка.', twitterTitle: 'Intent-Driven Development (IDD) за агентно програмиране', twitterDescription: 'Управляем код вместо хаос от промптове: IDD превръща смисъла, решенията и сценариите в оперативни артефакти.', url: 'https://paioneer-labs.eu/agenticdev', structuredData: { '@context': 'https://schema.org', '@type': 'Service', name: 'Intent-Driven Development (IDD) за агентно програмиране', serviceType: 'Агентна софтуерна разработка и процеси на разработка с помощта на ИИ', description: 'Консултиране и реализация за Intent-Driven Development, IDD Vault, работни процеси за агентно програмиране и проверима софтуерна разработка с помощта на ИИ.', provider: { '@type': 'Organization', name: 'pAIoneer Labs GmbH', url: 'https://paioneer-labs.eu' }, areaServed: 'DE, NL, EU', url: 'https://paioneer-labs.eu/agenticdev' } }, hero: { eyebrow: 'Агентното програмиране се нуждае от изричен контекст', title: 'Intent-Driven Development', claim: 'Смисъл преди реализация.', lead: 'ИИ пише код. IDD се грижи той да работи по правилния проблем. Intent-Driven Development превръща целите, границите, решенията и сценариите в оперативни артефакти за агентната софтуерна разработка.' }, implicitContextProblem: { title: 'Рискът е неявният контекст', intro: 'Истинският риск при софтуерната разработка с помощта на ИИ не е липсващият код. Рискът е контекстът, който остава скрит в нечия глава, в историята на чата или в разпилени тикети.', items: [{ title: 'Неясна задача', description: 'Промптовете често описват решение, но не и целта, това, което не е цел, критериите за успех и допусканията. Тогава ИИ работи бързо, но не непременно в правилната посока.' }, { title: 'Случайна архитектура', description: 'Технологичните решения се вземат между другото: съхранението на данните, изборът на модел, случаите на отказ и експлоатацията се решават неявно, вместо да се водят съзнателно.' }, { title: 'Непроверим резултат', description: 'Без сценарии и критерии за приемане остава неясно дали кодът наистина се държи правилно, или само изглежда правдоподобно.' }], resolution: 'IDD решава точно този проблем: първо се операционализира смисълът, а след това от него се извежда кодът.' }, antiVibeCoding: { title: 'Vibe Coding не е процес на разработка', description: 'За демонстрации интуицията може и да стига. За софтуер с експлоатация, поддръжка, сигурност, разходи и отговорност тя не стига. Агентите не се нуждаят от повече настроение, а от изричен контекст.', contrasts: ['Vibe Coding създава движение. IDD създава посока.', 'Промптовете създават отговори. IDD създава проектна памет.', 'Агентното програмиране без IDD остава активност. Агентното програмиране с IDD се превръща в управляема разработка.'] }, principle: { title: 'Документацията не е страничен продукт', thesis: 'В IDD документацията е оперативен артефакт.', description: 'Документацията не служи за отчетност. Тя е работното пространство, в което целите, границите, решенията и очакваното поведение стават изрични, преди агентите да пристъпят към реализацията.', pillarsTitle: 'Намерение. Решения. Сценарии. Код.', pillarsIntro: 'IDD не свежда софтуерната разработка до промптове, а прави смисъла на проекта изричен и извежда от него проверима реализация.', pillars: [{ title: 'Намерение (Intent)', description: 'Какво трябва да бъде постигнато, какво изрично е извън обхвата и по какво разпознаваме успеха?' }, { title: 'Решения (Decisions)', description: 'Кои важни решения са взети, в какъв контекст и с какви последици?' }, { title: 'Сценарии (Scenarios)', description: 'Какво поведение се очаква в нормални случаи, в гранични случаи, при откази и в ситуации на приемане?' }, { title: 'Код (Code)', description: 'Реализацията произтича от документирания смисъл и се проверява спрямо сценариите и стъпките за проверка.' }] }, vault: { title: 'IDD Vault: проектна памет вместо история на промптове', description: 'IDD Vault съхранява значимия контекст там, където агентите и хората могат да го използват отново. Не повече файлове от необходимото. Всеки файл има ясна функция.', rule: 'Малко артефакти. Ясно предназначение. Траен контекст.', effect: 'IDD Vault не позволява решаващият контекст да изчезне в чата, в нечия глава или в разпилени тикети.', treeLines: ['/project', '  /idd_vault', '    intent.md       # цел, какво не е цел, критерии за успех, допускания', '    decisions.md    # решения с контекст, обосновка, последици', '    scenarios.md    # поведение, гранични случаи, критерии за приемане', '  /code', '  AGENTS.md         # правила и очаквания към кодовите агенти', '  README.md         # въведение, настройка, режим на работа, граници'] }, outputs: { title: 'Не текст. Управляем код.', description: 'Файловете на IDD не са доклад. Те са входни данни за конкретната работа по реализацията и за връщането на наученото обратно в проекта.', items: [{ file: 'intent.md', result: 'Обхват', description: 'Крайните точки, моделът на данните, критериите за успех, това, което не е цел, и допусканията стават видими като рамка на разработката.' }, { file: 'decisions.md', result: 'Архитектура', description: 'Технологията, експлоатацията, съхранението на данните, изборът на модел и компромисите се обосновават, вместо да се решават между другото.' }, { file: 'scenarios.md', result: 'Тестове', description: 'Тестовете за приемане, режимите на отказ, преходите между състояния и граничните случаи възникват преди или по време на реализацията.' }, { file: 'AGENTS.md', result: 'Качество на кода', description: 'Правилата, шаблоните, ограниченията, миграциите, OpenAPI и очакваните резултати стават изрични за агентите.' }, { file: 'README.md', result: 'Входна точка', description: 'Настройката, режимът на работа, границите и примерните процеси остават разбираеми за хора и агенти.' }, { file: 'Код', result: 'Обратна връзка', description: 'Наученото от реализацията и проверката се връща в IDD Vault, в тестовете и в следващата итерация.' }] }, comparison: { title: 'IDD започва преди спецификацията', intro: 'Spec-Driven Development е силен подход, когато целта вече е технически точна и стабилна. IDD започва по-рано: там, където предметната област, допусканията, компромисите и режимите на отказ тепърва трябва да бъдат направени изрични.', columns: ['Подход', 'Център', 'Сила', 'Ограничение'], rows: [{ approach: 'Работа с промптове', center: 'Заявка към модел', strength: 'Бързо и директно', limit: 'Мимолетно, непълно и трудно проверимо' }, { approach: 'Vibe Coding', center: 'Интуиция и итерация', strength: 'Полезно за експерименти и демонстрации', limit: 'Няма надеждно управление за софтуер, за който се носи отговорност' }, { approach: 'Spec-Driven Development', center: 'Технически договор', strength: 'Последователност спрямо вече дефинирана спецификация', limit: 'Грешният проблем може да бъде реализиран формално коректно' }, { approach: 'Intent-Driven Development', center: 'Смисъл, цел и решения', strength: 'Изяснява контекста, компромисите и границите преди реализацията', limit: 'Изисква дисциплинирана поддръжка на контекста и валидиране' }], summary: 'Спецификациите казват какво трябва да е технически вярно. IDD обосновава защо трябва да се гради точно в тази посока.' }, workflow: { title: 'Изясняване. Решаване. Формулиране. Изграждане. Обратна връзка.', description: 'IDD не е водопаден модел. IDD е малка, контролирана итерация с траен контекст.', steps: [{ title: 'Изясняване на намерението', description: 'Целите, това, което не е цел, критериите за успех и допусканията стават видими, преди да бъде написан код.' }, { title: 'Документиране на решенията', description: 'Архитектурните и продуктовите решения се записват с контекст, обосновка и последици.' }, { title: 'Формулиране на сценариите', description: 'Нормалното поведение, граничните случаи, режимите на отказ и критериите за приемане се описват в проверим вид.' }, { title: 'Реализация от агентите', description: 'ИИ агентите работят въз основа на изричен контекст, а не на изолирани промптове.' }, { title: 'Проверка и обратна връзка', description: 'Наученото от кода, тестовете и експлоатацията актуализира IDD Vault и следващата итерация.' }] }, impact: { title: 'Защо това е важно в реалните проекти', description: 'IDD прави разработката с помощта на ИИ съвместима с екипите, експлоатацията и осигуряването на качеството.', items: ['По-малко преработване, защото е видимо какво е цел и какво не е.', 'По-добра архитектура, защото решенията са обосновани.', 'По-добри тестове, защото сценариите съществуват преди кода.', 'По-добро сътрудничество, защото контекстът не изчезва в чата.', 'По-добри резултати от агентите, защото всяка стъпка се основава на изрични артефакти.'] }, contact: { title: 'Въведете IDD в агентните процеси на разработка', description: 'Ако разработката с помощта на ИИ трябва да бъде нещо повече от експеримент, тя се нуждае от оперативен модел на контекста.', details: 'Помагаме при изграждането на IDD Vault, правила за агенти, сценарии и проверими работни процеси на разработка.', button: 'Обсъдете IDD', subject: 'Обсъждане на Intent-Driven Development', email: 'info@paioneer.eu' } },
    impressum: injectPersonalData('bg', baseTranslationBG)
  }
};
